// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-11-03T20:34:03.526Z
// Property: Lodge @ 1550 (ID: 5652147039371264)
// Collections: 19 amenities, 8 floorplans (live), 21 photos, 80 POIs, 4 reviews, 1 virtual tours, 6 office hours, 1 special offers (live)
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5695708787113984",
  "multihub_property_id": "5652147039371264",
  "property_external_id": "4600726",
  "property_zillow_url": "https://www.zillow.com/homedetails/1550-Katy-Flewellen-Rd-Katy-TX-77494/2123605516_zpid/",
  "property_apartments_url": "https://www.apartments.com/lodge-1550-katy-tx/h4xe5n2",
  "property_google_business_url": "https://www.google.com/maps/place/Lodge+@+1550/@29.766731,-95.8225743,15z/data=!4m2!3m1!1s0x0:0x3b22f6593c272c50?sa=X&ved=2ahUKEwjZov3gkeL2AhUqmWoFHTs1DD0Q_BJ6BAgSEAU",
  "property_linkedin_url": null,
  "property_hubspot_id": "8443838469",
  "property_crm_software": "Rent Dynamics",
  "property_pm_software": "RealPage",
  "property_pm_info": null,
  "property_status": null,
  "property_slug": "lodge-@-1550",
  "property_name": "Lodge @ 1550",
  "property_website_url": "https://www.lodgeat1550.com/",
  "property_domain": "https://www.lodgeat1550.com/",
  "property_address": "1550 Katy Flewellen Rd",
  "property_full_address": "1550 Katy Flewellen Rd, Katy, TX 77494",
  "property_address_1": "1550 Katy Flewellen Rd",
  "property_address_2": null,
  "property_address_city": "Katy",
  "property_address_state": "TX",
  "property_address_zip_full": "77494-5508",
  "property_address_zip": "77494",
  "property_address_country": "US",
  "property_address_county": "Fort Bend County",
  "property_neighborhood_address": "Cinco Ranch",
  "property_address_latitude": "29.7670101",
  "property_address_longitude": "-95.82252799999999",
  "property_email": "lodge@alapts.com",
  "property_phone": "(281) 392-2787",
  "property_call_tracking_phone": "346-487-6373",
  "property_company_name": "American Landmark",
  "property_company_url": "https://www.alapts.com/",
  "agency_contacts": null,
  "property_type": "apartment",
  "property_short_description": "<p><strong>Relaxed Katy living, polished where it counts.</strong> Discover updated one- and two-bedroom apartments with elevated finishes, everyday comfort, and calm landscaped surroundings—then schedule your tour of Lodge @ 1550 today.</p>",
  "property_long_description": "<p><strong>Relaxed Katy living, polished where it counts.</strong> Lodge @ 1550 brings you updated one- and two-bedroom apartments in the Cinco Ranch area with the everyday comforts that make home feel easy: chef-style kitchens in select homes with stainless steel appliances, quartz countertops, glass tile backsplashes and white shaker cabinetry, plus hardwood-style flooring, built-in bookshelves, walk-in closets, private patios or balconies, and available wood-burning fireplaces. Around the community, unwind at the <a href=\"/amenities\">resort-inspired pool</a> and heated spa, grill in the picnic courtyards, stay active in the fitness center, or let your pup stretch out at the Bark Park.</p><p>Beyond the community, you’re close to the best of west Katy: open-air shopping and dining at LaCenterra at Cinco Ranch, outlet finds and entertainment at Katy Mills, green space at Willow Fork Park, and everyday errands from H-E-B, Kroger and Costco. With access to Grand Parkway, I-10 and Route 90, Lodge @ 1550 keeps your routine connected while giving you a calm, landscaped place to come back to.</p>",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5652147039371264/019d02ef-1574-70dc-b240-759c996b8517.webp",
  "property_featured_image_media": {
    "alt_text": "Modern kitchen with white cabinets, stainless steel appliances, and quartz countertops.",
    "public_id": "019d02ef-1574-70dc-b240-759c996b8517",
    "storage_key": "property/5652147039371264/019d02ef-1574-70dc-b240-759c996b8517.webp",
    "width": 1240,
    "height": 827
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "204",
  "property_year_built": "1984",
  "property_year_renovated": "2020",
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "94.6078431372549",
  "property_admin_fee": "150",
  "property_application_fee": "75",
  "property_fees_deposit_info": "Application Fee $75\nAdministrative Fee $150\nNon-Refundable Pet Fee $400 / pet\nMonthly Pet Rent $35 / pet\nApplication Approval Fee Starting At $300",
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "400",
  "property_pet_deposit": null,
  "property_monthly_pet_rent": "35",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": null,
  "property_pet_restrictions": "Breed restrictions may apply. Contact us for more information.",
  "property_pet_policy_description": "We happily accept cats and dogs, up to 2 per home, with no weight limit. We have a one-time non-refundable pet fee of $400 per pet, with a monthly pet rent of $35 per pet. Breed restrictions may apply.",
  "property_petpolicy_info": "We happily accept cats and dogs, up to 2 per home, with no weight limit. We have a one-time non-refundable pet fee of $400 per pet, with a monthly pet rent of $35 per pet. Breed restrictions may apply.",
  "property_online_leasing_url": "https://8113532.onlineleasing.realpage.com",
  "property_resident_portal_url": "https://lodgeat1550.loftliving.com/login",
  "property_apply_now_url": "https://8113532.onlineleasing.realpage.com",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5652147039371264/019e6fd2-6756-712b-b6a2-340a39c86eb7.webp",
  "property_primary_logo_media": {
    "alt_text": "Lodge @ 1550 Premier Apartments logo with a tree and a horse silhouette.",
    "public_id": "019e6fd2-6756-712b-b6a2-340a39c86eb7",
    "storage_key": "property/5652147039371264/019e6fd2-6756-712b-b6a2-340a39c86eb7.webp",
    "width": 1332,
    "height": 1172
  },
  "property_secondary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5652147039371264/019e6fd2-6792-73ce-9390-2574972d308a.webp",
  "property_secondary_logo_media": {
    "alt_text": "Lodge @ 1550 Premier Apartments logo with tree and horse.",
    "public_id": "019e6fd2-6792-73ce-9390-2574972d308a",
    "storage_key": "property/5652147039371264/019e6fd2-6792-73ce-9390-2574972d308a.webp",
    "width": 1332,
    "height": 1172
  },
  "property_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5652147039371264/019e6fd2-66fc-71fe-b2ac-539623399122.webp",
  "property_icon_media": {
    "alt_text": "Tree and horse logo",
    "public_id": "019e6fd2-66fc-71fe-b2ac-539623399122",
    "storage_key": "property/5652147039371264/019e6fd2-66fc-71fe-b2ac-539623399122.webp",
    "width": 830,
    "height": 830
  },
  "property_fav_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5652147039371264/019e6fd2-66fc-71fe-b2ac-539623399122.webp",
  "property_fav_icon_media": {
    "alt_text": "Tree and horse logo",
    "public_id": "019e6fd2-66fc-71fe-b2ac-539623399122",
    "storage_key": "property/5652147039371264/019e6fd2-66fc-71fe-b2ac-539623399122.webp",
    "width": 830,
    "height": 830
  },
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5652147039371264/019f42e9-d2b3-7098-be59-e856ddc59f73.webp",
  "property_mono_white_logo_media": {
    "alt_text": null,
    "public_id": "019f42e9-d2b3-7098-be59-e856ddc59f73",
    "storage_key": "property/5652147039371264/019f42e9-d2b3-7098-be59-e856ddc59f73.webp",
    "width": 1280,
    "height": 1126
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5652147039371264/019f42e9-af84-74cc-be2f-733034d2fa59.webp",
  "property_mono_black_logo_media": {
    "alt_text": null,
    "public_id": "019f42e9-af84-74cc-be2f-733034d2fa59",
    "storage_key": "property/5652147039371264/019f42e9-af84-74cc-be2f-733034d2fa59.webp",
    "width": 1280,
    "height": 1126
  },
  "property_company_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/019d02ed-af4c-707a-be5f-eaefee6b31cf.webp",
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/019d02ed-c9dc-7579-9b73-fbe42f847d6f.webp",
  "property_company_logo_media": {
    "alt_text": "American Landmark logo",
    "public_id": "019d02ed-c9dc-7579-9b73-fbe42f847d6f",
    "storage_key": "company/5695708787113984/019d02ed-c9dc-7579-9b73-fbe42f847d6f.webp",
    "width": 1968,
    "height": 884
  },
  "property_company_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/019d02ed-b73c-7581-ab8a-b01c3434f867.webp",
  "property_company_mono_black_logo_media": {
    "alt_text": "American Landmark logo",
    "public_id": "019d02ed-b73c-7581-ab8a-b01c3434f867",
    "storage_key": "company/5695708787113984/019d02ed-b73c-7581-ab8a-b01c3434f867.webp",
    "width": 2565,
    "height": 1000
  },
  "property_company_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/019d02ed-bfec-74fd-b5d0-5a699636306b.webp",
  "property_company_mono_white_logo_media": {
    "alt_text": "American Landmark logo on a black background",
    "public_id": "019d02ed-bfec-74fd-b5d0-5a699636306b",
    "storage_key": "company/5695708787113984/019d02ed-bfec-74fd-b5d0-5a699636306b.webp",
    "width": 2565,
    "height": 1000
  },
  "property_primary_color": "#75994a",
  "property_secondary_color": "#5a2d2c",
  "property_font_color": "#2e2a25",
  "property_color_4": null,
  "property_color_3": "#b6d295",
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "1 - 2",
  "property_bedrooms_min": "1",
  "property_bedrooms_max": "2",
  "property_bathrooms_range": "1 - 2",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "2",
  "property_sqft_range": "532 - 946",
  "property_sqft_min": "532",
  "property_sqft_max": "946",
  "property_price_range": "1014 - 1639.66",
  "property_price_min": "1014",
  "property_price_max": "1639.66",
  "property_available_units": 11,
  "property_facebook_url": "https://www.facebook.com/Lodgeat1550",
  "property_instagram_url": "https://www.instagram.com/lodgeat1550",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJh_im4RokQYYRUCwnPFn2Ijs",
  "property_youtube_url": "https://www.youtube.com/channel/UCni4YDpLrrxw4SiTnGW8eng/about",
  "property_yelp_url": "https://www.yelp.com/biz/carriage-inn-katy",
  "property_tiktok_url": null,
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": null,
  "property_home_romance_title": null,
  "property_home_amenities_blurb": "<p><strong>Amenities that keep the day moving.</strong> Start with coffee in the clubhouse, fit in a workout, unwind by the pool, or gather in the courtyard with grills and picnic seating. Lodge @ 1550 also brings a Bark Park, door-to-door trash pickup, online resident services, on-site maintenance, and laundry options—plus select apartment finishes like quartz-style counters, stainless steel appliances, glass tile backsplashes, white shaker cabinetry, hardwood-style floors, private outdoor space, and available fireplaces.</p>",
  "property_home_floorplans_blurb": "<p><strong>Find the layout that fits.</strong> Explore one- and two-bedroom apartments in Katy with polished finishes in select homes, including quartz countertops, stainless steel appliances, glass tile backsplashes, and white shaker-style cabinetry. Walk-in closets, built-in bookshelves, private patios or balconies, and available wood-burning fireplaces add everyday character to your space.</p>",
  "property_home_gallery_blurb": "<p><strong>See Lodge @ 1550 in focus.</strong> Preview bright Katy apartments with crisp kitchens, tile accents, patios or balconies, and select homes with built-in shelving or wood-burning fireplaces. Then picture the wider scene: landscaped courtyards, grilling areas, a pool with heated spa, clubhouse, fitness space, laundry lounge, and Bark Park—all captured in the gallery.</p>",
  "property_home_neighborhood_blurb": "<p><strong>Cinco Ranch days, Katy convenience.</strong> Start with bruschetta at Postino, a film at Alamo Drafthouse, or open-air browsing at LaCenterra. When the pace slows, Willow Fork Park brings boardwalks, lake views, disc golf, and paved trails. With Grand Parkway, Westpark Tollway, and I-10 nearby, west Houston and the Energy Corridor stay easy to reach. Explore the map, then schedule a closer look at Lodge @ 1550.</p>",
  "property_home_reviews_blurb": "<p><strong>Residents praise the service that makes Lodge @ 1550 stand out.</strong> Reviews call out a “professional and nice” team, attentive office staff, quick maintenance response, and a welcoming everyday experience in Cinco Ranch. Read the full reviews to see why one resident says it simply: “I love living here staff is amazing!”</p>",
  "property_neighborhood_blurb": "<p><strong>Find your pace in Cinco Ranch.</strong> From Lodge @ 1550, your Katy routine feels easy to map out: grab wine and bruschetta at Postino, catch a movie at Alamo Drafthouse, or wander LaCenterra’s open-air streets when Central Green has something on the lawn. For slower hours, Willow Fork Park brings boardwalks, lake views, disc golf, and paved trails; for wider plans, Grand Parkway, Westpark Tollway, and I-10 help keep west Houston and the Energy Corridor within reach. Back home, the community’s <a href=\"/amenities\">pool, clubhouse, fitness center, and Bark Park</a> give you simple ways to reset without leaving the property. Explore the map below to find the everyday stops and local favorites that can shape your next Katy routine, then <a href=\"/schedule-a-tour\">schedule a tour</a> to see the setting for yourself.</p>",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "<p><strong>Thoughtful perks, all close to your front door.</strong> At Lodge @ 1550, your day can move from coffee at the clubhouse to a fitness-center workout, a poolside break, or an evening in the courtyard with grills and picnic seating. The Bark Park adds an easy outdoor stop for your pet, while door-to-door trash pickup, 24/7 online services, on-site maintenance, and laundry options help simplify the practical side of apartment living in Katy.</p><p>Inside, select homes bring a more polished finish with quartz-style counters, stainless steel appliances, glass tile backsplashes, white shaker cabinetry, and hardwood-style floors. Everyday details—like generous closets, built-in shelving, private outdoor space, washer/dryer options, and available fireplaces—make your layout feel more complete. See more in the <a href=\"/gallery\">photo gallery</a>, then <a href=\"/schedule-a-tour\">schedule a tour</a> to experience the amenities in person.</p>",
  "property_applynow_blurb": "<p><strong>Ready to make Lodge @ 1550 home?</strong><br>Start your online application for updated one- and two-bedroom apartments with polished finishes, easy everyday comforts, and a calm, landscaped Katy setting to come back to. Apply now and take the next step toward relaxed living that feels effortless.</p>",
  "property_contactus_blurb": "<p><strong>Questions? We’re here to help.</strong><br>Reach out to the Lodge @ 1550 leasing team for details on updated one- and two-bedroom apartments, current availability, or directions to our calm, landscaped community in the Cinco Ranch area of Katy.</p>",
  "property_faqs_blurb": "<p><strong>Questions about Lodge @ 1550?</strong> Start here for quick answers about the community, leasing, amenities, and everyday living in our updated one- and two-bedroom apartments in Katy. If you need anything beyond the FAQs, the leasing team is happy to help.</p>",
  "property_floorplans_blurb": "<p><strong>Compare your options with confidence.</strong> Lodge @ 1550 offers one-bedroom and two-bedroom apartments in Katy, giving you a focused lineup of layouts to match your space needs, finish preferences, and move-in timing. Select homes bring a polished look with quartz countertops, stainless steel appliances, decorative glass tile backsplashes, and white shaker-style cabinetry, while everyday details like walk-in closets, built-in bookshelves, private patios or balconies, and available wood-burning fireplaces help each floor plan feel complete. Browse current pricing and availability, explore more <a href=\"/amenities\">in-home features</a>, then <a href=\"/schedule-a-tour\">schedule a tour</a> to see how your favorite layout feels in person.</p>",
  "property_gallery_blurb": "<p><strong>Picture your day at Lodge @ 1550.</strong> Browse the gallery for the details that make this Katy apartment community feel inviting from the first look: sunlit kitchens with crisp cabinetry and tile accents, comfortable living spaces that open to a patio or balcony, and select homes with built-in shelving or a wood-burning fireplace for extra character. Outside, the camera moves from landscaped courtyards and grilling spots to the <a href=\"/amenities\">pool and heated spa</a>, where loungers and open sky set an easygoing scene. You’ll also spot the clubhouse, fitness space, laundry lounge, and Bark Park woven into the community. Like what you see? Explore the <a href=\"/virtual-tours\">virtual tours</a>, then <a href=\"/schedule-a-tour\">see it in person</a>.</p>",
  "property_interactivemap_blurb": "<p><strong>Map your next move.</strong> Use the interactive map to explore available apartments at Lodge @ 1550 and see how this calm, landscaped Katy community connects to shopping, dining, parks, everyday errands, and key routes across west Katy.</p>",
  "property_pets_blurb": "<p><strong>Pets aren’t an afterthought here.</strong> At Lodge @ 1550, your cat or dog has room to settle in without a weigh-in, plus everyday pet-friendly perks that make apartment living feel easier in Katy. Start the morning with a quick trip to the on-site Bark Park, take a shaded stroll through the courtyards, then come back to a floor plan with practical comforts like walk-in closets, private patio or balcony options, and easy-care finishes in select homes.</p><p>With up to two pets welcome per home and community spaces built for fresh air, play, and simple routines, Lodge @ 1550 gives you more than a pet-friendly policy—it gives your four-legged roommate a better daily rhythm. Have questions about breed guidelines or fees? <a href=\"/contact-us\">Contact the leasing team</a> before you apply.</p>",
  "property_referafriend_blurb": "<p><strong>Share relaxed Katy living.</strong><br>Love the polished apartment finishes, calm landscaped setting, pool and spa, fitness center, Bark Park, and easy access to west Katy essentials? Refer a friend to Lodge @ 1550 and invite them to find their next home here.</p>",
  "property_residentaccess_blurb": "<p><strong>Resident Access at Lodge @ 1550.</strong><br>Keep your routine easy from your calm Katy home base. Log in to pay rent, submit maintenance requests, and manage your account—then get back to enjoying relaxed living in a polished, landscaped community.</p>",
  "property_reviews_blurb": "<p><strong>See what residents are saying about Lodge @ 1550.</strong> Reviews highlight a community where helpful service stands out—from a “professional and nice” team to office staff described as attentive, kind, and ready to help. Residents also point to quick attention when something needs fixing and an everyday experience that feels easy and welcoming.</p><p>As you browse the full reviews, you’ll find praise for the property itself, the responsive team, and the convenience that makes life at this Cinco Ranch apartment community feel simple. One resident sums it up best: “I love living here staff is amazing!”</p>",
  "property_created_at": "1752256401862",
  "property_scheduletour_blurb": "<p><strong>See relaxed Katy living up close.</strong><br>Tour updated one- and two-bedroom apartments with polished finishes in select homes, inviting outdoor spaces, and a calm landscaped setting. Schedule your visit to experience Lodge @ 1550 in person and find the layout that feels right.</p>",
  "property_thankyou_blurb": "<p><strong>Thank you—we’ve received your inquiry.</strong><br>Our leasing team will follow up soon with next steps. In the meantime, picture relaxed Katy living at Lodge @ 1550, where updated one- and two-bedroom apartments, polished finishes, inviting outdoor spaces, and a calm landscaped setting make coming home feel easy.</p>",
  "property_virtualtours_blurb": "<p><strong>Step inside before you stop by.</strong> The virtual tours at Lodge @ 1550 let you explore the community from wherever you are, with walkthroughs of the overall grounds, Leasing Office Lounge, Fitness Center, Pool, and a one-bedroom apartment layout. Move at your own pace, pause on the details, and get a better feel for how the lounge areas, workout space, pool setting, and in-home finishes come together in this Katy apartment community.</p><p>Use the 1 BR, 1 BA tour to picture the flow of daily living, then compare current <a href=\"/floor-plans\">floor plans</a> or <a href=\"/schedule-a-tour\">schedule a tour</a> when you’re ready to see Lodge @ 1550 in person.</p>",
  "property_copyright": "2025 All Rights Reserved. Lodge @ 1550",
  "property_seo_title_home": "Lodge @ 1550 | Apartments in Katy, TX",
  "property_seo_description_home": "Discover your ideal living space at Lodge @ 1550 in Katy, TX! Our community offers spacious one and two-bedroom floor plans, complete with modern amenities like built-in bookcases, stylish tile backsplashes, and hard floor options. Enjoy resort-style living with a sparkling pool, dog park, and resident clubhouse. With online resident services and convenient laundry rooms, comfort and ease are just steps away. Don't miss your chance to find the perfect home with stunning views and exceptional features—explore our floor plans today and take the first step towards your new lifestyle!",
  "property_seo_title_floorplans": "Floor Plans | 1 - 2 Apartments in Katy, TX",
  "property_seo_description_floorplans": "Discover your ideal living space at Lodge @ 1550 in Katy, TX! Explore our diverse floor plans, featuring stylish one and two-bedroom apartments designed for comfort and convenience. Browse our available apartment homes today and find the perfect floor plan that suits your lifestyle!",
  "property_seo_title_amenities": "Amenities | Katy, TX Apartments for Rent",
  "property_seo_description_amenities": "\"Discover Lodge @ 1550 in Katy, TX, where luxury meets comfort! Explore our diverse floor plans, including spacious one and two-bedroom apartments, each featuring modern amenities like built-in bookcases, kitchen appliances, and stained tile backsplashes. Enjoy the exceptional community offerings: relax by the pool, unwind at our resident clubhouse, or take a stroll through the dog park. Experience convenience with online resident services and laundry rooms in select homes. Your ideal living space awaits—explore our amazing community amenities and apartment features today!\"",
  "property_seo_title_gallery": "Gallery | Apartments in Katy, TX",
  "property_seo_description_gallery": "\"Explore the stunning photo gallery of Lodge @ 1550 in Katy, TX, and visualize your future home! Discover our spacious one and two-bedroom floor plans featuring modern amenities like built-in bookcases, gourmet kitchen appliances, and luxurious wood plank flooring. Enjoy resort-style living with access to a sparkling pool, serene dog park, and vibrant resident clubhouse. Picture yourself in our inviting spaces with captivating views and top-notch resident services. Click to see all that Lodge @ 1550 has to offer and imagine your life here!\"",
  "property_seo_title_virtualtours": "Virtual Tours | Lodge @ 1550 Apartments",
  "property_seo_description_virtualtours": "Discover your dream home at Lodge @ 1550 in Katy, TX! Explore our spacious one and two-bedroom floor plans and take an immersive virtual tour of our vibrant community. Experience modern living and exceptional amenities—schedule your virtual tour today and find your perfect apartment for rent!",
  "property_seo_title_interactivemap": "Interactive Map | Lodge @ 1550 Apartments",
  "property_seo_description_interactivemap": "Discover your perfect apartment at Lodge @ 1550 in Katy, TX! Explore our spacious one and two-bedroom floor plans featuring modern amenities like built-in bookcases, laundry rooms, and kitchen appliances. Enjoy community perks including a sparkling pool, dog park, and resident clubhouse. Visit our interactive community map today to search available apartments, view pricing, and select your ideal home with stunning views! ",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in Katy, TX",
  "property_seo_description_neighborhood": "Discover the vibrant neighborhood surrounding Lodge @ 1550 in Katy, TX! Explore our one and two-bedroom floor plans, and see what's around our community. Dive into local favorites and nearby points of interest—your ideal lifestyle awaits!",
  "property_seo_title_contact": "Contact Us | Lodge @ 1550",
  "property_seo_description_contact": "Discover your perfect home at Lodge @ 1550 in Katy, TX! Explore our thoughtfully designed one and two-bedroom floor plans to find the ideal space for you. Have questions? Contact our leasing team today for personalized assistance and to schedule a tour!",
  "property_seo_title_faqs": "FAQs | Apartments in Katy, TX",
  "property_seo_description_faqs": "Discover life at Lodge @ 1550 in Katy, TX, where luxury meets convenience. Explore our diverse floor plans, including one- and two-bedroom apartments, thoughtfully designed with modern amenities like built-in bookcases, full kitchen appliances, and cozy fireplaces. Enjoy exclusive access to our resort-style pool, dog park, and resident clubhouse, along with online resident services for hassle-free living. Have questions? Browse our FAQs page now to find the answers you need about our vibrant community!",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Katy, TX",
  "property_seo_description_reviews": "Discover the Lodge @ 1550 in Katy, TX, where exceptional living meets modern comfort! Explore our diverse floor plans, including one- and two-bedroom options, designed with amenities such as a refreshing pool, dog park, and luxurious resident clubhouse. Enjoy built-in features like bookcases and kitchen appliances, as well as stylish wood plank flooring and beautiful views. Don't just take our word for it—see what our residents have to say about their experience in our vibrant community! Start your journey to a new home today!",
  "property_seo_title_applynow": "Apply Now | Apartments in Katy, TX",
  "property_seo_description_applynow": "Discover your ideal living space at Lodge @ 1550 in Katy, TX! Choose from our spacious one and two-bedroom floor plans featuring modern amenities such as built-in bookcases, sleek kitchen appliances, and stunning tile backsplashes. Enjoy our exceptional community perks, including a refreshing pool, fire pit, dog park, and a vibrant resident clubhouse. Whether you prefer a first or second-floor apartment, embrace the comfort of wood plank flooring and beautiful views. Ready to elevate your lifestyle? Find your new home and lease online today!",
  "property_seo_title_residentaccess": "Resident Access | Lodge @ 1550",
  "property_seo_description_residentaccess": "\"Log in to the Lodge @ 1550 resident portal in Katy, TX, to effortlessly manage your living experience! Pay rent, schedule maintenance, and access exclusive community resources—all in one convenient place. Join us today!\"",
  "property_seo_title_referafriend": "Refer A Friend | Lodge @ 1550",
  "property_seo_description_referafriend": "\"Discover the Lodge @ 1550 in Katy, TX! Refer a friend and enjoy exclusive rewards as you welcome great neighbors to our vibrant community. Great friends make great neighbors—spread the word today!\"",
  "property_seo_title_scheduletour": "Schedule a Tour | Lodge @ 1550",
  "property_seo_description_scheduletour": "Explore the Lodge @ 1550 in Katy, TX! Discover your ideal apartment home surrounded by modern amenities and beautiful surroundings. Schedule a tour of our community today and see why residents love calling Lodge @ 1550 home!",
  "property_seo_title_privacy": "Privacy Policy | Lodge @ 1550",
  "property_seo_description_privacy": "\"At Lodge @ 1550 in Katy, TX, your privacy matters! Explore our comprehensive privacy policy to understand how we protect your information and ensure a secure living experience. View our privacy policy today!\"",
  "property_seo_title_accessibility": "Website Accessibility | Lodge @ 1550",
  "property_seo_description_accessibility": "Discover a community where everyone belongs at Lodge @ 1550 in Katy, TX. Our Accessibility Statement underscores our commitment to digital inclusion, ensuring all visitors can easily navigate our site. Join us today and experience a welcoming place to call home.",
  "property_seo_title_sitemap": "Sitemap | Lodge @ 1550",
  "property_seo_description_sitemap": "\"Explore Lodge @ 1550 in Katy, TX! Discover our comprehensive sitemap for easy navigation through our vibrant community and find the perfect apartment to call home. View now!\"",
  "property_seo_title_thankyou": "Thank You | Lodge @ 1550",
  "property_seo_description_thankyou": "Thank you for reaching out to Lodge @ 1550 in Katy, TX! Your information has been received, and a member of our dedicated team will contact you shortly to discuss your new home. We look forward to helping you discover the perfect apartment community!",
  "property_seo_title_pets": "Pet Policy | Apartments in Jacksonville, FL\r",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1791234320032",
  "amenities": [
    {
      "id": "custom_c7acaac8-06d5-4d7f-b5ab-0315f3c2b7d5",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5652147039371264",
      "source": "custom",
      "external_id": "P000000597",
      "title": "American Landmark 360",
      "amount": "0.0000",
      "description": "American Landmark 360 Resident Program",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_e0d2ba6d-245d-4c6c-af0c-13b33a0dc2a5",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5652147039371264",
      "source": "custom",
      "external_id": "P000000604",
      "title": "Built-In Bookcase",
      "amount": "0.0000",
      "description": "Built-In Bookshelves",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_fca3e99e-b5bb-4ee5-8530-565fcd709743",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5652147039371264",
      "source": "custom",
      "external_id": "P000000606",
      "title": "Built-In Microwave",
      "amount": "0.0000",
      "description": "Built-In Microwave",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_5bdf2876-0d6e-4ca5-9783-2068966ea726",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5652147039371264",
      "source": "custom",
      "external_id": "P000000609",
      "title": "Cabinets",
      "amount": "0.0000",
      "description": "White Shaker Style Cabinetry",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_7d896cfc-f0b9-4bab-96b7-856d3bc9eb70",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5652147039371264",
      "source": "custom",
      "external_id": "P000000621",
      "title": "Counters",
      "amount": "0.0000",
      "description": "Quartz & Designer Finished Countertops*",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_ae3b6cd1-c46f-41e7-9349-d5ce99dca672",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5652147039371264",
      "source": "custom",
      "external_id": "P000000626",
      "title": "Dog Park",
      "amount": "0.0000",
      "description": "Bark Park for your Furry Friends",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_9b0d8935-5219-460d-9472-bd030e608ffa",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5652147039371264",
      "source": "custom",
      "external_id": "P000000633",
      "title": "Fire",
      "amount": "0.0000",
      "description": "Wood Burning Fireplaces*",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_27eb5363-6921-4211-9ec5-c58e437c59f3",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5652147039371264",
      "source": "custom",
      "external_id": "P000000646",
      "title": "Hard Floors",
      "amount": "0.0000",
      "description": "Hardwood Style Flooring",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_a912d2f3-537d-4283-900d-734d4bda805d",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5652147039371264",
      "source": "custom",
      "external_id": "P000000651",
      "title": "Kitchen Appliances",
      "amount": "0.0000",
      "description": "Stainless Steel Appliances*",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_a3b2c80c-4acd-4a2c-87a2-b7452b7e53fc",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5652147039371264",
      "source": "custom",
      "external_id": "P000000656",
      "title": "Laundry Rooms",
      "amount": "0.0000",
      "description": "Laundry Lounge Area",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_6265bc2e-8f83-4088-970b-278de475af53",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5652147039371264",
      "source": "custom",
      "external_id": "P000000660",
      "title": "Online Resident Services",
      "amount": "0.0000",
      "description": "Convenient 24/7 Online Resident Services",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_536a6508-3703-4282-8832-611fb9dd9063",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5652147039371264",
      "source": "custom",
      "external_id": "P000000669",
      "title": "Pool",
      "amount": "0.0000",
      "description": "Resort-Inspired Pool w/ Sundeck",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_714d949d-4d9b-4f34-bc8e-df5fa34e3e79",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5652147039371264",
      "source": "custom",
      "external_id": "P000000675",
      "title": "Select Homes",
      "amount": "0.0000",
      "description": "*In Select Homes",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_6c1e3cc2-1760-4a3f-8975-2cb0f54ab3c4",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5652147039371264",
      "source": "custom",
      "external_id": "P000000682",
      "title": "Spa",
      "amount": "0.0000",
      "description": "Relaxing Heated Spa",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_0b2d5c10-9404-40a0-8ab4-043f75881715",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5652147039371264",
      "source": "custom",
      "external_id": "P000000695",
      "title": "Tile Backsplash",
      "amount": "0.0000",
      "description": "Decorative Glass Tile Backsplash",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_3b9b8dd1-9e24-4e53-a728-86ba856f956f",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5652147039371264",
      "source": "custom",
      "external_id": "P000000700",
      "title": "Views",
      "amount": "0.0000",
      "description": "Serene Scenic Views Available",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_52f6c61d-9a8b-453d-8b9f-2eaa8d5fd2a5",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5652147039371264",
      "source": "custom",
      "external_id": "P000000703",
      "title": "W&D Connections",
      "amount": "0.0000",
      "description": "Full-Size Washer & Dryer Connections",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_a0e895dc-b6a1-492b-9a10-970e6b58da6c",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5652147039371264",
      "source": "custom",
      "external_id": "P000001279",
      "title": "BBQ",
      "amount": "0.0000",
      "description": "BBQ & Picnic Areas",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_f1dfd64f-f942-4181-9232-4facf6caac09",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5652147039371264",
      "source": "custom",
      "external_id": "P000002520",
      "title": "Resident Clubhouse",
      "amount": "0.0000",
      "description": "Resident Clubhouse",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "custom_f5144b95-52fe-40f1-9912-91fe5fc1eaec",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5652147039371264",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5652147039371264/019e89a0-431f-718f-916c-f05822869304.webp",
      "image_media": {
        "alt_text": "Playground structure with ramps and tunnels.",
        "public_id": "019e89a0-431f-718f-916c-f05822869304",
        "storage_key": "property/5652147039371264/019e89a0-431f-718f-916c-f05822869304.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Children's playground structure featuring ramps and tunnels, located outdoors on a grassy area with apartment buildings in the background.",
      "link": "",
      "alt_text": "Playground structure with ramps and tunnels.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_dfac349c-3ba9-41a1-9a34-cd4aa22e3716",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5652147039371264",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5652147039371264/019e89a0-4780-739d-a9dd-23b11203081b.webp",
      "image_media": {
        "alt_text": "Modern bathroom with a vanity, toilet, and shower/tub combo.",
        "public_id": "019e89a0-4780-739d-a9dd-23b11203081b",
        "storage_key": "property/5652147039371264/019e89a0-4780-739d-a9dd-23b11203081b.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Experience comfort and style in our well-appointed apartment bathrooms, featuring a clean vanity, modern fixtures, and a refreshing shower/tub combo.",
      "link": "",
      "alt_text": "Modern bathroom with a vanity, toilet, and shower/tub combo.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_c3fb617d-740e-485f-acd7-aeaaed54f587",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5652147039371264",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5652147039371264/019e89a0-4233-76c9-b737-6422adf23e70.webp",
      "image_media": {
        "alt_text": "Secure package lockers with property logo 'Lodge @ 1550 Premium Apartments'.",
        "public_id": "019e89a0-4233-76c9-b737-6422adf23e70",
        "storage_key": "property/5652147039371264/019e89a0-4233-76c9-b737-6422adf23e70.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Modern package lockers provide secure 24/7 access for residents, featuring the 'Lodge @ 1550' branding.",
      "link": "",
      "alt_text": "Secure package lockers with property logo 'Lodge @ 1550 Premium Apartments'.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_c1e61064-0b4e-4d6c-bac8-ad77066acb0b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5652147039371264",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5652147039371264/019e89a0-41e7-75c3-bc02-67248f92d3a6.webp",
      "image_media": {
        "alt_text": "Modern bedroom with a king-size bed, green accents, and a large abstract painting.",
        "public_id": "019e89a0-41e7-75c3-bc02-67248f92d3a6",
        "storage_key": "property/5652147039371264/019e89a0-41e7-75c3-bc02-67248f92d3a6.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Stylish bedroom featuring a comfortable king-size bed with plush pillows, complemented by a dark dresser and a minimalist aesthetic. Perfect for relaxation.",
      "link": "",
      "alt_text": "Modern bedroom with a king-size bed, green accents, and a large abstract painting.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_2bb7606f-6097-47a2-8086-375ab314bcc2",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5652147039371264",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5652147039371264/019e89a0-3ddc-70d9-b26e-9fb850b02446.webp",
      "image_media": {
        "alt_text": "Lounge chairs and dining set by a brick building with an umbrella.",
        "public_id": "019e89a0-3ddc-70d9-b26e-9fb850b02446",
        "storage_key": "property/5652147039371264/019e89a0-3ddc-70d9-b26e-9fb850b02446.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Relax and unwind by the sparkling pool area, featuring comfortable lounge chairs and an outdoor dining set perfect for enjoying the sunshine.",
      "link": "",
      "alt_text": "Lounge chairs and dining set by a brick building with an umbrella.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_843624bb-c9db-425c-b190-6d067ff35b1d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5652147039371264",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5652147039371264/019e89a0-3f8a-7627-aa70-d46727df0013.webp",
      "image_media": {
        "alt_text": "Lounge area with coffee bar, adjacent to a glass-enclosed fitness center.",
        "public_id": "019e89a0-3f8a-7627-aa70-d46727df0013",
        "storage_key": "property/5652147039371264/019e89a0-3f8a-7627-aa70-d46727df0013.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Relax and recharge in our stylish lounge, complete with a coffee bar, or break a sweat in our state-of-the-art fitness center, both accessible to residents.",
      "link": "",
      "alt_text": "Lounge area with coffee bar, adjacent to a glass-enclosed fitness center.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_179b4ab9-7f09-4f3b-96ca-b4e8d071d12a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5652147039371264",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5652147039371264/019e89a0-33f1-76ec-af7e-ea8d4b056338.webp",
      "image_media": {
        "alt_text": "Kitchen with stainless steel appliances, white cabinets, and a double sink.",
        "public_id": "019e89a0-33f1-76ec-af7e-ea8d4b056338",
        "storage_key": "property/5652147039371264/019e89a0-33f1-76ec-af7e-ea8d4b056338.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Modern kitchen featuring stainless steel appliances, ample cabinet storage, and a spacious double sink, perfect for any home chef.",
      "link": "",
      "alt_text": "Kitchen with stainless steel appliances, white cabinets, and a double sink.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_4c9ffa19-8a59-48e3-8ba1-e954abe3967f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5652147039371264",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5652147039371264/019e89a0-34fe-7388-a77e-61a0c2337c83.webp",
      "image_media": {
        "alt_text": "Dining area with a marble-top table, gray chairs, and abstract art.",
        "public_id": "019e89a0-34fe-7388-a77e-61a0c2337c83",
        "storage_key": "property/5652147039371264/019e89a0-34fe-7388-a77e-61a0c2337c83.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Enjoy meals in this elegantly appointed dining area, featuring a stylish marble-top table, comfortable seating, and a vibrant abstract art piece.",
      "link": "",
      "alt_text": "Dining area with a marble-top table, gray chairs, and abstract art.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_f2a9e601-2217-4eb8-b185-7d1b8027a740",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5652147039371264",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5652147039371264/019e89a0-33ec-73d3-b0ee-0cabbe661d2a.webp",
      "image_media": {
        "alt_text": "Fitness center with cardio machines and free weights.",
        "public_id": "019e89a0-33ec-73d3-b0ee-0cabbe661d2a",
        "storage_key": "property/5652147039371264/019e89a0-33ec-73d3-b0ee-0cabbe661d2a.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Stay active in our state-of-the-art fitness center, equipped with cardio machines, weight machines, and free weights.",
      "link": "",
      "alt_text": "Fitness center with cardio machines and free weights.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_9b596ab2-f3fe-495f-8071-2ee8830929ea",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5652147039371264",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5652147039371264/019e89a0-319a-70ed-9908-30d5b94c47de.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool and jacuzzi area with lounge chairs and apartment buildings in the background.",
        "public_id": "019e89a0-319a-70ed-9908-30d5b94c47de",
        "storage_key": "property/5652147039371264/019e89a0-319a-70ed-9908-30d5b94c47de.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Relax and unwind by our sparkling outdoor swimming pool and soothing jacuzzi. Enjoy the sun and fresh air with ample lounge seating and poolside tables, perfect for gathering with friends or family.",
      "link": "",
      "alt_text": "Outdoor swimming pool and jacuzzi area with lounge chairs and apartment buildings in the background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_9761b1f4-8ba8-4c60-b445-306bcbd452e3",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5652147039371264",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5652147039371264/019e89a0-2d67-7038-8bfa-232c1e09bf30.webp",
      "image_media": {
        "alt_text": "Open-concept living and dining area with a modern kitchen.",
        "public_id": "019e89a0-2d67-7038-8bfa-232c1e09bf30",
        "storage_key": "property/5652147039371264/019e89a0-2d67-7038-8bfa-232c1e09bf30.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious open-concept apartment featuring a modern kitchen, a comfortable living area with a vibrant sofa, and a dining space.",
      "link": "",
      "alt_text": "Open-concept living and dining area with a modern kitchen.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_99800d6e-85a8-4619-b167-e564b2ebd8a5",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5652147039371264",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5652147039371264/019e89a0-1f87-74a0-ac26-53bd9350a098.webp",
      "image_media": {
        "alt_text": "Gym with cardio machines, weight machines, and free weights.",
        "public_id": "019e89a0-1f87-74a0-ac26-53bd9350a098",
        "storage_key": "property/5652147039371264/019e89a0-1f87-74a0-ac26-53bd9350a098.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "State-of-the-art fitness center with a variety of cardio and weight training equipment for residents.",
      "link": "",
      "alt_text": "Gym with cardio machines, weight machines, and free weights.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_62a2278e-5251-47bd-a687-96516b67f95a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5652147039371264",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5652147039371264/019e89a0-2124-73ae-8d38-2ccecd8b19b9.webp",
      "image_media": {
        "alt_text": "Empty walk-in closet with hanging clothes and laundry basket.",
        "public_id": "019e89a0-2124-73ae-8d38-2ccecd8b19b9",
        "storage_key": "property/5652147039371264/019e89a0-2124-73ae-8d38-2ccecd8b19b9.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious walk-in closet with ample hanging space and a laundry basket, perfect for organizing your wardrobe.",
      "link": "",
      "alt_text": "Empty walk-in closet with hanging clothes and laundry basket.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_14e93335-ed77-4f92-bb52-efc86f9482b3",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5652147039371264",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5652147039371264/019e89a0-1fd4-713e-819e-aaef55f56260.webp",
      "image_media": {
        "alt_text": "The Lodge apartment community entrance sign with landscaping.",
        "public_id": "019e89a0-1fd4-713e-819e-aaef55f56260",
        "storage_key": "property/5652147039371264/019e89a0-1fd4-713e-819e-aaef55f56260.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Welcome to The Lodge, a beautiful apartment community. Our entrance features a prominent sign and lush landscaping, creating a welcoming atmosphere for residents and visitors.",
      "link": "",
      "alt_text": "The Lodge apartment community entrance sign with landscaping.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_bb5627f5-3cd6-4b93-b1ed-5df595604101",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5652147039371264",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5652147039371264/019e89a0-2139-76ec-962f-a6019cbd34e7.webp",
      "image_media": {
        "alt_text": "Exterior view of apartment buildings with walkways and green lawn.",
        "public_id": "019e89a0-2139-76ec-962f-a6019cbd34e7",
        "storage_key": "property/5652147039371264/019e89a0-2139-76ec-962f-a6019cbd34e7.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Charming apartment buildings with brick and siding exteriors, surrounded by manicured lawns and walkways. Offering a peaceful and pleasant living environment.",
      "link": "",
      "alt_text": "Exterior view of apartment buildings with walkways and green lawn.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_a3fdddf2-d4f0-4244-a883-58d1ffb61da7",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5652147039371264",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5652147039371264/019e89a0-212c-73ad-beec-428bc9929477.webp",
      "image_media": {
        "alt_text": "Modern living room with a lime green sofa, glass coffee table, and decorative camera art.",
        "public_id": "019e89a0-212c-73ad-beec-428bc9929477",
        "storage_key": "property/5652147039371264/019e89a0-212c-73ad-beec-428bc9929477.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Step into comfort in this stylish living room, featuring a vibrant lime green sofa, a sleek glass coffee table, and unique camera-themed wall art. Perfect for relaxing or entertaining.",
      "link": "",
      "alt_text": "Modern living room with a lime green sofa, glass coffee table, and decorative camera art.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_6c1f79f1-9919-4bea-9c15-129faa486b50",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5652147039371264",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5652147039371264/019e89a0-1519-750d-9fed-b51593da6f04.webp",
      "image_media": {
        "alt_text": "Spacious lounge area with sectional sofa, coffee table, and gym equipment visible through glass partition.",
        "public_id": "019e89a0-1519-750d-9fed-b51593da6f04",
        "storage_key": "property/5652147039371264/019e89a0-1519-750d-9fed-b51593da6f04.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Relax in our stylish lounge area, complete with comfortable seating and a state-of-the-art fitness center just steps away.",
      "link": "",
      "alt_text": "Spacious lounge area with sectional sofa, coffee table, and gym equipment visible through glass partition.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_08efc9e0-cb85-49ad-8e05-0f6a0094e0be",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5652147039371264",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5652147039371264/019e89a0-137d-76b9-8a75-c0874ca6eb1e.webp",
      "image_media": {
        "alt_text": "Luxury apartment community pool area with lounge chairs, outdoor grills, and seating.",
        "public_id": "019e89a0-137d-76b9-8a75-c0874ca6eb1e",
        "storage_key": "property/5652147039371264/019e89a0-137d-76b9-8a75-c0874ca6eb1e.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Relax and unwind by our sparkling swimming pool, complete with comfortable lounge chairs, outdoor grills, and shaded seating areas. Perfect for enjoying the warm weather and socializing with neighbors.",
      "link": "",
      "alt_text": "Luxury apartment community pool area with lounge chairs, outdoor grills, and seating.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_448cdcdc-c5c8-463c-bfb5-23fc0bea21d2",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5652147039371264",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5652147039371264/019e89a0-1457-73fd-a057-7fcf61bc5254.webp",
      "image_media": {
        "alt_text": "Aerial view of a resort-style swimming pool and lounge area with umbrellas and chairs.",
        "public_id": "019e89a0-1457-73fd-a057-7fcf61bc5254",
        "storage_key": "property/5652147039371264/019e89a0-1457-73fd-a057-7fcf61bc5254.webp",
        "width": 3072,
        "height": 2303
      },
      "title": "Community",
      "description": "Relax and unwind by our stunning swimming pool, featuring comfortable loungers, shaded umbrellas, and a soothing spa. Perfect for a sunny afternoon.",
      "link": "",
      "alt_text": "Aerial view of a resort-style swimming pool and lounge area with umbrellas and chairs.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_f62f5a92-152a-4257-a99f-be9686fd4e1a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5652147039371264",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5652147039371264/019e89a0-0f4d-774e-adf0-430c94c34747.webp",
      "image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs, umbrellas, and an outdoor kitchen area.",
        "public_id": "019e89a0-0f4d-774e-adf0-430c94c34747",
        "storage_key": "property/5652147039371264/019e89a0-0f4d-774e-adf0-430c94c34747.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling swimming pool, perfect for relaxing or entertaining guests. Outdoor kitchen and lounge areas available.",
      "link": "",
      "alt_text": "Resort-style swimming pool with lounge chairs, umbrellas, and an outdoor kitchen area.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_3d49b83d-19d3-4827-acf3-230a153f903a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5652147039371264",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5652147039371264/019e89a0-0ecd-729b-8477-ca7a1718c924.webp",
      "image_media": {
        "alt_text": "Modern living and dining area with a lime green sofa and marble dining table.",
        "public_id": "019e89a0-0ecd-729b-8477-ca7a1718c924",
        "storage_key": "property/5652147039371264/019e89a0-0ecd-729b-8477-ca7a1718c924.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Experience elegant living in this beautifully appointed apartment featuring a spacious living area and a sophisticated dining space, perfect for entertaining.",
      "link": "",
      "alt_text": "Modern living and dining area with a lime green sofa and marble dining table.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "ec_819a54ee3a683662bf5e8191",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5652147039371264",
      "source": "generator",
      "poi_name": "Goodcents",
      "poi_type": "Restaurants",
      "poi_address": "2206 Katy Flewellen Rd E, Katy, TX 77494, USA",
      "poi_short_description": "Casual eatery serving classic sandwiches in a family-friendly space with friendly staff.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5652147039371264/019f1501-af63-7308-9b32-6dbb18bbcb0a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1501-af63-7308-9b32-6dbb18bbcb0a",
        "storage_key": "property/5652147039371264/019f1501-af63-7308-9b32-6dbb18bbcb0a.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=756983195852359493&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "goodcents",
      "poi_latitude": "29.7581261",
      "poi_longitude": "-95.8313687",
      "poi_miles_from_property": "0.9 mi",
      "poi_walking_minutes": "20 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 346-387-6724",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5652147039371264/019f1500-2d10-70a9-8127-37b32506d702.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1500-2d10-70a9-8127-37b32506d702",
        "storage_key": "property/5652147039371264/019f1500-2d10-70a9-8127-37b32506d702.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJXzH30C4XQYYRRUe4uTRYgQo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "sandwich_shop"
    },
    {
      "id": "ec_d1e4d4bfa239e73ef37b3f7d",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5652147039371264",
      "source": "generator",
      "poi_name": "Yaya's Poboys",
      "poi_type": "Restaurants",
      "poi_address": "2212 Katy Flewellen Rd, Katy, TX 77494, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5652147039371264/019f1501-aee4-76eb-b5c9-eb82107371b2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1501-aee4-76eb-b5c9-eb82107371b2",
        "storage_key": "property/5652147039371264/019f1501-aee4-76eb-b5c9-eb82107371b2.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=3378450328724508467&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "yayas-poboys",
      "poi_latitude": "29.7580253",
      "poi_longitude": "-95.8315942",
      "poi_miles_from_property": "0.9 mi",
      "poi_walking_minutes": "20 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5652147039371264/019f1500-2d10-70a9-8127-37b32506d702.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1500-2d10-70a9-8127-37b32506d702",
        "storage_key": "property/5652147039371264/019f1500-2d10-70a9-8127-37b32506d702.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJXyqT530lQYYRMw_tlqyq4i4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "ec_3d795cb9255d1bb77c35e901",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5652147039371264",
      "source": "generator",
      "poi_name": "The Coffee Pot",
      "poi_type": "Restaurants",
      "poi_address": "2212 Katy Flewellen Rd Ste 300, Katy, TX 77494, USA",
      "poi_short_description": "Venezuelan-inspired restaurant featuring pastries, empanadas and sandwiches.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5652147039371264/019f1501-aee0-748e-988f-f754be01527a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1501-aee0-748e-988f-f754be01527a",
        "storage_key": "property/5652147039371264/019f1501-aee0-748e-988f-f754be01527a.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=7315907508674560165&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-coffee-pot",
      "poi_latitude": "29.7580539",
      "poi_longitude": "-95.8316025",
      "poi_miles_from_property": "0.9 mi",
      "poi_walking_minutes": "20 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 346-608-4265",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5652147039371264/019f1501-ff62-7589-a58a-136bfe210947.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1501-ff62-7589-a58a-136bfe210947",
        "storage_key": "property/5652147039371264/019f1501-ff62-7589-a58a-136bfe210947.webp",
        "width": 192,
        "height": 144
      },
      "poi_google_place_id": "ChIJdSmB77AlQYYRpQApKB5Th2U",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "coffee_shop"
    },
    {
      "id": "ec_e50983860d36017ad7e8d1e5",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5652147039371264",
      "source": "generator",
      "poi_name": "Lozano's Mexican-Latin Cocina",
      "poi_type": "Restaurants",
      "poi_address": "1251 Pin Oak Rd, Katy, TX 77494, USA",
      "poi_short_description": "Margaritas and fajitas come standard at this casual Mexican eatery with friendly staff.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5652147039371264/019f1501-ab37-7237-b9ae-53e8c4f6c20c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1501-ab37-7237-b9ae-53e8c4f6c20c",
        "storage_key": "property/5652147039371264/019f1501-ab37-7237-b9ae-53e8c4f6c20c.webp",
        "width": 926,
        "height": 617
      },
      "poi_business_url": "http://lozanosmexicanrestaurant.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1184442358170772514&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lozanos-mexican-latin-cocina",
      "poi_latitude": "29.7726146",
      "poi_longitude": "-95.8170486",
      "poi_miles_from_property": "5.7 mi",
      "poi_walking_minutes": "2 hours 6 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 281-665-8639",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5652147039371264/019f1500-2d10-70a9-8127-37b32506d702.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1500-2d10-70a9-8127-37b32506d702",
        "storage_key": "property/5652147039371264/019f1500-2d10-70a9-8127-37b32506d702.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJQRAzMdElQYYRIuSxnwz8bxA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "ec_ddd185327ca9eddc9c6cc5fa",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5652147039371264",
      "source": "generator",
      "poi_name": "Cicis Pizza",
      "poi_type": "Restaurants",
      "poi_address": "1251 Pin Oak Rd, Katy, TX 77494, USA",
      "poi_short_description": "Italian chain offering an array of specialty pizzas, plus classic pastas & salads.",
      "poi_long_description": "Italian chain offering an array of specialty pizzas, plus classic pastas & salads.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5652147039371264/019f1501-aafb-700a-bfe1-da66771a2d77.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1501-aafb-700a-bfe1-da66771a2d77",
        "storage_key": "property/5652147039371264/019f1501-aafb-700a-bfe1-da66771a2d77.webp",
        "width": 1280,
        "height": 723
      },
      "poi_business_url": "https://www.cicis.com/locations/tx-katy-1251-pin-oak-rd?utm_source=google&utm_medium=local&utm_campaign=google-local",
      "poi_directions_map_url": "https://maps.google.com/?cid=13769013577494044533&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cicis-pizza",
      "poi_latitude": "29.7724393",
      "poi_longitude": "-95.8177023",
      "poi_miles_from_property": "5.7 mi",
      "poi_walking_minutes": "2 hours 7 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 281-693-7992",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5652147039371264/019f1500-2d10-70a9-8127-37b32506d702.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1500-2d10-70a9-8127-37b32506d702",
        "storage_key": "property/5652147039371264/019f1500-2d10-70a9-8127-37b32506d702.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJVfTmvx4kQYYRdR8QuuVcFb8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pizza_restaurant"
    },
    {
      "id": "ec_14a54d2ad2923c55fd3f93cf",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5652147039371264",
      "source": "generator",
      "poi_name": "Texas Borders Bar and Grill",
      "poi_type": "Restaurants",
      "poi_address": "1251 Pin Oak Rd #141, Katy, TX 77494, USA",
      "poi_short_description": "Neighborhood stop for Tex-Mex, Cajun & American fare, plus drink specials & a family-friendly vibe.",
      "poi_long_description": "Neighborhood stop for Tex-Mex, Cajun & American fare, plus drink specials & a family-friendly vibe.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5652147039371264/019f1501-ab34-76ab-a1be-a1f7a2bbca44.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1501-ab34-76ab-a1be-a1f7a2bbca44",
        "storage_key": "property/5652147039371264/019f1501-ab34-76ab-a1be-a1f7a2bbca44.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.texasbordersbarandgrill.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17089591266214414015&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "texas-borders-bar-and-grill",
      "poi_latitude": "29.7732065",
      "poi_longitude": "-95.81695460000002",
      "poi_miles_from_property": "5.6 mi",
      "poi_walking_minutes": "2 hours 5 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 281-578-8785",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5652147039371264/019f1500-2d10-70a9-8127-37b32506d702.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1500-2d10-70a9-8127-37b32506d702",
        "storage_key": "property/5652147039371264/019f1500-2d10-70a9-8127-37b32506d702.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJldibhprYQIYRvwZUS7ZsKu0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "family_restaurant"
    },
    {
      "id": "ec_a8f5f4b88b3ca5ec643464fb",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5652147039371264",
      "source": "generator",
      "poi_name": "Pizza Bella Katy",
      "poi_type": "Restaurants",
      "poi_address": "1306 Pin Oak Rd, Katy, TX 77494, USA",
      "poi_short_description": "Basic Italian eatery specializing in hand-thrown, thin-crust pizza & housemade desserts.",
      "poi_long_description": "Basic Italian eatery specializing in hand-thrown, thin-crust pizza & housemade desserts.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5652147039371264/019f1501-ae80-74a9-b1b9-a80cdb56dcd0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1501-ae80-74a9-b1b9-a80cdb56dcd0",
        "storage_key": "property/5652147039371264/019f1501-ae80-74a9-b1b9-a80cdb56dcd0.webp",
        "width": 1080,
        "height": 608
      },
      "poi_business_url": "https://www.pizzabellaofkaty.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1978656650602522128&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "pizza-bella-katy",
      "poi_latitude": "29.7708823",
      "poi_longitude": "-95.8182646",
      "poi_miles_from_property": "5.7 mi",
      "poi_walking_minutes": "2 hours 7 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 281-693-3880",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5652147039371264/019f1500-2d10-70a9-8127-37b32506d702.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1500-2d10-70a9-8127-37b32506d702",
        "storage_key": "property/5652147039371264/019f1500-2d10-70a9-8127-37b32506d702.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJfwj7IRwkQYYREKagh72ZdRs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pizza_restaurant"
    },
    {
      "id": "ec_de87038b3c6e1edd2b0f54a1",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5652147039371264",
      "source": "generator",
      "poi_name": "El Rancho Mexican Restaurant",
      "poi_type": "Restaurants",
      "poi_address": "17754 Katy Fwy Ste B, Houston, TX 77094, USA",
      "poi_short_description": "Big menu of standard Tex-Mex dishes plus margaritas in a family-friendly venue with a covered patio.",
      "poi_long_description": "Big menu of standard Tex-Mex dishes plus margaritas in a family-friendly venue with a covered patio.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5652147039371264/019f1501-ab60-74db-96c4-92a9a2e6fafc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1501-ab60-74db-96c4-92a9a2e6fafc",
        "storage_key": "property/5652147039371264/019f1501-ab60-74db-96c4-92a9a2e6fafc.webp",
        "width": 1280,
        "height": 662
      },
      "poi_business_url": "https://www.elranchokaty.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17790811396493111627&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "el-rancho-mexican-restaurant",
      "poi_latitude": "29.7858645",
      "poi_longitude": "-95.6862705",
      "poi_miles_from_property": "11.8 mi",
      "poi_walking_minutes": "4 hours 21 mins",
      "poi_biking_minutes": "1 hour 2 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 281-492-9677",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5652147039371264/019f1500-2d10-70a9-8127-37b32506d702.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1500-2d10-70a9-8127-37b32506d702",
        "storage_key": "property/5652147039371264/019f1500-2d10-70a9-8127-37b32506d702.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJiytzm4jYQIYRS3HxkbSo5fY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "ec_c1c954fcd1ee3efc7e86bbbd",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5652147039371264",
      "source": "generator",
      "poi_name": "Carrabba's Italian Grill",
      "poi_type": "Restaurants",
      "poi_address": "6501 S Fry Rd, Katy, TX 77494, USA",
      "poi_short_description": "Chain eatery & bar serving a diverse menu of classic Italian fare in a family-friendly setting.",
      "poi_long_description": "Chain eatery & bar serving a diverse menu of classic Italian fare in a family-friendly setting.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5652147039371264/019f1501-af55-7650-b6c8-80a0feb8e2af.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1501-af55-7650-b6c8-80a0feb8e2af",
        "storage_key": "property/5652147039371264/019f1501-af55-7650-b6c8-80a0feb8e2af.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://locations.carrabbas.com/texas/katy/6501-fry-road?y_source=1_MTU1MDI5NjEtNzE1LWxvY2F0aW9uLndlYnNpdGU%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=5330895330219584467&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "carrabbas-italian-grill",
      "poi_latitude": "29.712926",
      "poi_longitude": "-95.7705562",
      "poi_miles_from_property": "6.3 mi",
      "poi_walking_minutes": "2 hours 20 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 281-665-1320",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5652147039371264/019f1500-2d10-70a9-8127-37b32506d702.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1500-2d10-70a9-8127-37b32506d702",
        "storage_key": "property/5652147039371264/019f1500-2d10-70a9-8127-37b32506d702.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJTb33T_4gQYYR0-uG_A4l-0k",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "italian_restaurant"
    },
    {
      "id": "ec_f85883ad246aedb28b3ed0a0",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5652147039371264",
      "source": "generator",
      "poi_name": "Russo's New York Pizzeria & Italian Kitchen - Katy Reserve",
      "poi_type": "Restaurants",
      "poi_address": "1708 Spring Green Blvd, Katy, TX 77494, USA",
      "poi_short_description": "Casual chain serving pizza along with soups, sandwiches & pastas.",
      "poi_long_description": "Casual chain serving pizza along with soups, sandwiches & pastas.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5652147039371264/019f1501-ade4-766e-aea5-f4ec4b591231.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1501-ade4-766e-aea5-f4ec4b591231",
        "storage_key": "property/5652147039371264/019f1501-ade4-766e-aea5-f4ec4b591231.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://order.toasttab.com/online/russos-new-york-pizzeria-katy-reserve",
      "poi_directions_map_url": "https://maps.google.com/?cid=9881909666390574424&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "russos-new-york-pizzeria--italian-kitchen---katy-reserve",
      "poi_latitude": "29.7641224",
      "poi_longitude": "-95.8438056",
      "poi_miles_from_property": "2.1 mi",
      "poi_walking_minutes": "47 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 832-981-7727",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5652147039371264/019f1500-2d10-70a9-8127-37b32506d702.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1500-2d10-70a9-8127-37b32506d702",
        "storage_key": "property/5652147039371264/019f1500-2d10-70a9-8127-37b32506d702.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJny4RKnAkQYYRWIW1J3yYI4k",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "italian_restaurant"
    },
    {
      "id": "ec_d523bd3d6642bc5f4461343b",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5652147039371264",
      "source": "generator",
      "poi_name": "Marco's Pizza",
      "poi_type": "Restaurants",
      "poi_address": "5030 Franz Rd Ste 101, Katy, TX 77493, USA",
      "poi_short_description": "Counter-serve chain serving up a menu of specialty or custom pizzas for takeout or delivery.",
      "poi_long_description": "Counter-serve chain serving up a menu of specialty or custom pizzas for takeout or delivery.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5652147039371264/019f1501-b59a-704c-b2e7-fe7ff38eafaa.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1501-b59a-704c-b2e7-fe7ff38eafaa",
        "storage_key": "property/5652147039371264/019f1501-b59a-704c-b2e7-fe7ff38eafaa.webp",
        "width": 1024,
        "height": 576
      },
      "poi_business_url": "https://www.marcos.com/our-locations/restaurants/TX/Katy/marcos-pizza-franz-rd-katy-1",
      "poi_directions_map_url": "https://maps.google.com/?cid=1037978179596649301&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "marcos-pizza",
      "poi_latitude": "29.8021221",
      "poi_longitude": "-95.803277",
      "poi_miles_from_property": "5.7 mi",
      "poi_walking_minutes": "2 hours 7 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 281-371-6373",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5652147039371264/019f1500-2d10-70a9-8127-37b32506d702.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1500-2d10-70a9-8127-37b32506d702",
        "storage_key": "property/5652147039371264/019f1500-2d10-70a9-8127-37b32506d702.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJVfwvHK0nQYYRVQN3p6ejZw4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pizza_restaurant"
    },
    {
      "id": "ec_507d43d4dfec5476d600bebc",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5652147039371264",
      "source": "generator",
      "poi_name": "Denny's Restaurant",
      "poi_type": "Restaurants",
      "poi_address": "2405 Texmati Dr, Katy, TX 77494, USA",
      "poi_short_description": "Casual diner chain dishing up classic American comfort fare, including all-day breakfast favorites.",
      "poi_long_description": "Casual diner chain dishing up classic American comfort fare, including all-day breakfast favorites.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5652147039371264/019f1501-b7f4-7013-92ed-7894021e4f43.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1501-b7f4-7013-92ed-7894021e4f43",
        "storage_key": "property/5652147039371264/019f1501-b7f4-7013-92ed-7894021e4f43.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://locations.dennys.com/TX/KATY/247836?utm_source=G&utm_medium=organic&utm_campaign=DAC",
      "poi_directions_map_url": "https://maps.google.com/?cid=2277205261121823881&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "dennys-restaurant",
      "poi_latitude": "29.7821505",
      "poi_longitude": "-95.8097921",
      "poi_miles_from_property": "4.8 mi",
      "poi_walking_minutes": "1 hour 46 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 281-644-5555",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5652147039371264/019f1500-2d10-70a9-8127-37b32506d702.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1500-2d10-70a9-8127-37b32506d702",
        "storage_key": "property/5652147039371264/019f1500-2d10-70a9-8127-37b32506d702.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJSYgIzZ4mQYYRiSTRrR5Cmh8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "ec_4366c47d6ec2a00189aae6a8",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5652147039371264",
      "source": "generator",
      "poi_name": "Oh My Gyros Katy",
      "poi_type": "Restaurants",
      "poi_address": "806 Katy Fort Bend Rd #160A, Katy, TX 77493, USA",
      "poi_short_description": "Jumbo portions of rice platters, falafel & gyro wraps presented inside a convenience shop.",
      "poi_long_description": "Jumbo portions of rice platters, falafel & gyro wraps presented inside a convenience shop.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5652147039371264/019f1501-b90c-75ac-93a2-53732766e67e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1501-b90c-75ac-93a2-53732766e67e",
        "storage_key": "property/5652147039371264/019f1501-b90c-75ac-93a2-53732766e67e.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://ohmygyros.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11705179054418210604&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "oh-my-gyros-katy",
      "poi_latitude": "29.7866729",
      "poi_longitude": "-95.8007548",
      "poi_miles_from_property": "5.0 mi",
      "poi_walking_minutes": "1 hour 51 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 832-913-3816",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5652147039371264/019f1500-2d10-70a9-8127-37b32506d702.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1500-2d10-70a9-8127-37b32506d702",
        "storage_key": "property/5652147039371264/019f1500-2d10-70a9-8127-37b32506d702.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJiydwYOLDQIYRLK_wUlUmcaI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "ec_d04078fa9dc0e309095aa58e",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5652147039371264",
      "source": "generator",
      "poi_name": "T G Food Mart",
      "poi_type": "Shopping & Retail",
      "poi_address": "2709 Katy Flewellen Rd # A, Katy, TX 77494, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5652147039371264/019f1501-ba34-73bf-8181-989d7b8185b0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1501-ba34-73bf-8181-989d7b8185b0",
        "storage_key": "property/5652147039371264/019f1501-ba34-73bf-8181-989d7b8185b0.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=8950648968061102143&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "t-g-food-mart",
      "poi_latitude": "29.7497353",
      "poi_longitude": "-95.8353311",
      "poi_miles_from_property": "1.5 mi",
      "poi_walking_minutes": "32 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 281-371-0005",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5652147039371264/019f1501-ff63-7231-bc62-22f2c9b4c6dd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1501-ff63-7231-bc62-22f2c9b4c6dd",
        "storage_key": "property/5652147039371264/019f1501-ff63-7231-bc62-22f2c9b4c6dd.webp",
        "width": 192,
        "height": 161
      },
      "poi_google_place_id": "ChIJCWL3LosjQYYRP6h_WtAXN3w",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "convenience_store"
    },
    {
      "id": "ec_93badad6906fe97c5671dce5",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5652147039371264",
      "source": "generator",
      "poi_name": "Katy liquor",
      "poi_type": "Shopping & Retail",
      "poi_address": "1806 Avenue D #101, Katy, TX 77493, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5652147039371264/019f1501-b8a9-70ca-b62a-f0c3389f8fc7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1501-b8a9-70ca-b62a-f0c3389f8fc7",
        "storage_key": "property/5652147039371264/019f1501-b8a9-70ca-b62a-f0c3389f8fc7.webp",
        "width": 725,
        "height": 409
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=7489682454717263777&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "katy-liquor",
      "poi_latitude": "29.79819809999999",
      "poi_longitude": "-95.824588",
      "poi_miles_from_property": "4.4 mi",
      "poi_walking_minutes": "1 hour 38 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 281-665-8912",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5652147039371264/019f1500-2d22-7457-b0bb-a8ecc36cd5e6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1500-2d22-7457-b0bb-a8ecc36cd5e6",
        "storage_key": "property/5652147039371264/019f1500-2d22-7457-b0bb-a8ecc36cd5e6.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJob1OGJMlQYYRoe_lsYKy8Gc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "liquor_store"
    },
    {
      "id": "ec_c62aa2fa0e926f5701b4d84a",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5652147039371264",
      "source": "generator",
      "poi_name": "Kroger",
      "poi_type": "Shopping & Retail",
      "poi_address": "9806 Gaston Rd, Katy, TX 77494, USA",
      "poi_short_description": "Large supermarket chain with deli & bakery departments, plus health & beauty products.",
      "poi_long_description": "Large supermarket chain with deli & bakery departments, plus health & beauty products.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5652147039371264/019f1501-b67c-7716-a267-2a12c61e52d1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1501-b67c-7716-a267-2a12c61e52d1",
        "storage_key": "property/5652147039371264/019f1501-b67c-7716-a267-2a12c61e52d1.webp",
        "width": 480,
        "height": 270
      },
      "poi_business_url": "https://www.kroger.com/stores/grocery/tx/katy/gaston/034/00121?cid=loc_03400121_gmb",
      "poi_directions_map_url": "https://maps.google.com/?cid=5124918316172379153&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kroger",
      "poi_latitude": "29.736705",
      "poi_longitude": "-95.8100265",
      "poi_miles_from_property": "3.1 mi",
      "poi_walking_minutes": "1 hour 7 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 346-307-3054",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5652147039371264/019f1500-2d55-70eb-bf97-4e33b5400e50.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1500-2d55-70eb-bf97-4e33b5400e50",
        "storage_key": "property/5652147039371264/019f1500-2d55-70eb-bf97-4e33b5400e50.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ160urV4hQYYREQRZOg5eH0c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "ec_cf7e61581c71b8e52834dbbb",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5652147039371264",
      "source": "generator",
      "poi_name": "Kroger Marketplace",
      "poi_type": "Shopping & Retail",
      "poi_address": "1712 Spring Green Blvd, Katy, TX 77494, USA",
      "poi_short_description": "Large supermarket chain with deli & bakery departments, plus health & beauty products.",
      "poi_long_description": "Large supermarket chain with deli & bakery departments, plus health & beauty products.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5652147039371264/019f1501-b9ec-74c6-a5a1-ab2d4c0fab4e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1501-b9ec-74c6-a5a1-ab2d4c0fab4e",
        "storage_key": "property/5652147039371264/019f1501-b9ec-74c6-a5a1-ab2d4c0fab4e.webp",
        "width": 1280,
        "height": 577
      },
      "poi_business_url": "https://www.kroger.com/stores/grocery/tx/katy/firethorne/034/00146?cid=loc_03400146_gmb",
      "poi_directions_map_url": "https://maps.google.com/?cid=9905588313432626452&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kroger-marketplace",
      "poi_latitude": "29.7631577",
      "poi_longitude": "-95.8439221",
      "poi_miles_from_property": "2.0 mi",
      "poi_walking_minutes": "45 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 281-769-4360",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5652147039371264/019f1500-2d55-70eb-bf97-4e33b5400e50.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1500-2d55-70eb-bf97-4e33b5400e50",
        "storage_key": "property/5652147039371264/019f1500-2d55-70eb-bf97-4e33b5400e50.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJL9zpMHAkQYYRFJVpyRa4d4k",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "ec_ba341531f44d269d930806f9",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5652147039371264",
      "source": "generator",
      "poi_name": "Walmart Supercenter",
      "poi_type": "Shopping & Retail",
      "poi_address": "25108 Market Pl Dr, Katy, TX 77494, USA",
      "poi_short_description": "Department store chain selling electronics, clothing, toys, and home furnishings, plus groceries.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5652147039371264/019f1501-bc4e-709b-ae71-ce69cd454fbd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1501-bc4e-709b-ae71-ce69cd454fbd",
        "storage_key": "property/5652147039371264/019f1501-bc4e-709b-ae71-ce69cd454fbd.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.walmart.com/store/3226-katy-tx/?veh=seo_loc",
      "poi_directions_map_url": "https://maps.google.com/?cid=16713313748912289207&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walmart-supercenter",
      "poi_latitude": "29.78407129999999",
      "poi_longitude": "-95.8041471",
      "poi_miles_from_property": "4.7 mi",
      "poi_walking_minutes": "1 hour 45 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 281-644-6404",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5652147039371264/019f1500-2d22-7457-b0bb-a8ecc36cd5e6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1500-2d22-7457-b0bb-a8ecc36cd5e6",
        "storage_key": "property/5652147039371264/019f1500-2d22-7457-b0bb-a8ecc36cd5e6.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJPUR7qpAmQYYRt7WRv02e8ec",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "ec_75a0c481231df6884e874eac",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5652147039371264",
      "source": "generator",
      "poi_name": "Katy Mills",
      "poi_type": "Shopping & Retail",
      "poi_address": "5000 Katy Mills Cir, Katy, TX 77494, USA",
      "poi_short_description": "Complex with outlet stores for designer clothes, footwear & accessories, plus eateries & movies.",
      "poi_long_description": "Complex with outlet stores for designer clothes, footwear & accessories, plus eateries & movies.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5652147039371264/019f14ff-daa3-7478-bdbb-23e917592a4d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ff-daa3-7478-bdbb-23e917592a4d",
        "storage_key": "property/5652147039371264/019f14ff-daa3-7478-bdbb-23e917592a4d.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.simon.com/mall/katy-mills",
      "poi_directions_map_url": "https://maps.google.com/?cid=3336739692914759633&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "katy-mills",
      "poi_latitude": "29.7756348",
      "poi_longitude": "-95.8091819",
      "poi_miles_from_property": "5.2 mi",
      "poi_walking_minutes": "1 hour 55 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 281-644-5000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5652147039371264/019f1500-2d22-7457-b0bb-a8ecc36cd5e6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1500-2d22-7457-b0bb-a8ecc36cd5e6",
        "storage_key": "property/5652147039371264/019f1500-2d22-7457-b0bb-a8ecc36cd5e6.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ17sFi6EmQYYR0VchaBJ7Ti4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "ec_e5e4ad9d140a1420ab0fcd0b",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5652147039371264",
      "source": "generator",
      "poi_name": "LaCenterra at Cinco Ranch",
      "poi_type": "Shopping & Retail",
      "poi_address": "23501 Cinco Ranch Blvd, Katy, TX 77494, USA",
      "poi_short_description": "Outdoor shopping center with business offices, clothing, footwear, beauty & gift shops, plus dining.",
      "poi_long_description": "Outdoor shopping center with business offices, clothing, footwear, beauty & gift shops, plus dining.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5652147039371264/019f14ff-cdae-70ac-8787-b41bd5b49eb1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ff-cdae-70ac-8787-b41bd5b49eb1",
        "storage_key": "property/5652147039371264/019f14ff-cdae-70ac-8787-b41bd5b49eb1.webp",
        "width": 750,
        "height": 421
      },
      "poi_business_url": "https://lacenterra.com/?utm_source=gmb&utm_medium=Yext",
      "poi_directions_map_url": "https://maps.google.com/?cid=17500870136583917237&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lacenterra-at-cinco-ranch",
      "poi_latitude": "29.7429973",
      "poi_longitude": "-95.7750596",
      "poi_miles_from_property": "5.8 mi",
      "poi_walking_minutes": "2 hours 8 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 281-395-5533",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5652147039371264/019f1500-2d22-7457-b0bb-a8ecc36cd5e6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1500-2d22-7457-b0bb-a8ecc36cd5e6",
        "storage_key": "property/5652147039371264/019f1500-2d22-7457-b0bb-a8ecc36cd5e6.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ-W5CySchQYYRtY5TZ6qU3_I",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "ec_6a4a9ce04864b99e8a09d2f0",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5652147039371264",
      "source": "generator",
      "poi_name": "H-E-B plus!",
      "poi_type": "Shopping & Retail",
      "poi_address": "6711 S Fry Rd, Katy, TX 77494, USA",
      "poi_short_description": "Branch of a supermarket chain offering groceries, beer & wine, plus a deli, pharmacy & florist.",
      "poi_long_description": "Branch of a supermarket chain offering groceries, beer & wine, plus a deli, pharmacy & florist.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5652147039371264/019f1501-bca4-73af-8538-4812c73b33c0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1501-bca4-73af-8538-4812c73b33c0",
        "storage_key": "property/5652147039371264/019f1501-bca4-73af-8538-4812c73b33c0.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.heb.com/heb-store/US/tx/katy/grand-parkway-h-e-b-plus--596?utm_source=google&utm_medium=organic&utm_campaign=gmb_stores",
      "poi_directions_map_url": "https://maps.google.com/?cid=14000452733529731423&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "h-e-b-plus",
      "poi_latitude": "29.712764",
      "poi_longitude": "-95.775892",
      "poi_miles_from_property": "6.1 mi",
      "poi_walking_minutes": "2 hours 15 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 281-392-9500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5652147039371264/019f1500-2d55-70eb-bf97-4e33b5400e50.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1500-2d55-70eb-bf97-4e33b5400e50",
        "storage_key": "property/5652147039371264/019f1500-2d55-70eb-bf97-4e33b5400e50.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJi1ZENAEhQYYRX7GvZJWZS8I",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "ec_0ff68795c54e087c5de2296d",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5652147039371264",
      "source": "generator",
      "poi_name": "Walgreens",
      "poi_type": "Shopping & Retail",
      "poi_address": "6802 S Fry Rd, Katy, TX 77494, USA",
      "poi_short_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_long_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5652147039371264/019f1501-bd04-7185-b53c-e5d51a70daf2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1501-bd04-7185-b53c-e5d51a70daf2",
        "storage_key": "property/5652147039371264/019f1501-bd04-7185-b53c-e5d51a70daf2.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.walgreens.com/locator/walgreens-6802+s+fry+rd-katy-tx-77494/id=7491",
      "poi_directions_map_url": "https://maps.google.com/?cid=11534807102197288774&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walgreens",
      "poi_latitude": "29.7149365",
      "poi_longitude": "-95.7744527",
      "poi_miles_from_property": "6.1 mi",
      "poi_walking_minutes": "2 hours 13 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 281-392-0077",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5652147039371264/019f1500-2d79-729c-8bca-b8c9604f9307.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1500-2d79-729c-8bca-b8c9604f9307",
        "storage_key": "property/5652147039371264/019f1500-2d79-729c-8bca-b8c9604f9307.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJj89lhAEhQYYRRk8fB_LdE6A",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "drugstore"
    },
    {
      "id": "ec_53d95390a50482d038654d8d",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5652147039371264",
      "source": "generator",
      "poi_name": "Best Buy",
      "poi_type": "Shopping & Retail",
      "poi_address": "20290 Katy Fwy, Katy, TX 77449, USA",
      "poi_short_description": "Chain retailer with a large array of brand-name electronics, computers, appliances & more.",
      "poi_long_description": "Chain retailer with a large array of brand-name electronics, computers, appliances & more.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5652147039371264/019f1501-beed-724d-9e74-e1ee60831b52.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1501-beed-724d-9e74-e1ee60831b52",
        "storage_key": "property/5652147039371264/019f1501-beed-724d-9e74-e1ee60831b52.webp",
        "width": 1280,
        "height": 508
      },
      "poi_business_url": "https://stores.bestbuy.com/tx/katy/20290-katy-fwy-354.html/?ref=NS&loc=ns100",
      "poi_directions_map_url": "https://maps.google.com/?cid=7778924468868129988&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "best-buy",
      "poi_latitude": "29.7873966",
      "poi_longitude": "-95.7242881",
      "poi_miles_from_property": "9.6 mi",
      "poi_walking_minutes": "3 hours 31 mins",
      "poi_biking_minutes": "45 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 281-398-2938",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5652147039371264/019f1500-2d22-7457-b0bb-a8ecc36cd5e6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1500-2d22-7457-b0bb-a8ecc36cd5e6",
        "storage_key": "property/5652147039371264/019f1500-2d22-7457-b0bb-a8ecc36cd5e6.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJVVVVVeUnQYYRxKR6BZdK9Gs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "electronics_store"
    },
    {
      "id": "ec_b0470e993213ff6b3afa4135",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5652147039371264",
      "source": "generator",
      "poi_name": "MyPlace Early Learning Center- Katy",
      "poi_type": "Education",
      "poi_address": "2212 Katy Flewellen Rd, Katy, TX 77494, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5652147039371264/019f1501-c092-769d-af73-8b6322a40928.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1501-c092-769d-af73-8b6322a40928",
        "storage_key": "property/5652147039371264/019f1501-c092-769d-af73-8b6322a40928.webp",
        "width": 1024,
        "height": 1280
      },
      "poi_business_url": "https://www.myplacekaty.com/my-place-early-learning-center-katy",
      "poi_directions_map_url": "https://maps.google.com/?cid=6949501029127192391&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "myplace-early-learning-center--katy",
      "poi_latitude": "29.7577448",
      "poi_longitude": "-95.8319945",
      "poi_miles_from_property": "1.0 mi",
      "poi_walking_minutes": "21 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 281-305-8000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5652147039371264/019f1500-2d23-727e-9230-507918367794.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1500-2d23-727e-9230-507918367794",
        "storage_key": "property/5652147039371264/019f1500-2d23-727e-9230-507918367794.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ7aEP_gokQYYRR39Wr12WcWA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "preschool"
    },
    {
      "id": "ec_8da7ff357087a990519323d1",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5652147039371264",
      "source": "generator",
      "poi_name": "Primrose School of Woodcreek Reserve",
      "poi_type": "Education",
      "poi_address": "1249 FM 1463, Katy, TX 77494, USA",
      "poi_short_description": "Preschool, pre-K and daycare option providing infant and toddler care and after-school programs.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5652147039371264/019f1501-bf62-778a-a02d-455860bb80da.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1501-bf62-778a-a02d-455860bb80da",
        "storage_key": "property/5652147039371264/019f1501-bf62-778a-a02d-455860bb80da.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.primroseschools.com/schools/woodcreek-reserve/?utm_source=gbp&utm_medium=maplistings",
      "poi_directions_map_url": "https://maps.google.com/?cid=8020851357338138051&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "primrose-school-of-woodcreek-reserve",
      "poi_latitude": "29.7706141",
      "poi_longitude": "-95.8384456",
      "poi_miles_from_property": "2.4 mi",
      "poi_walking_minutes": "53 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 281-371-0099",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5652147039371264/019f1500-2d23-727e-9230-507918367794.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1500-2d23-727e-9230-507918367794",
        "storage_key": "property/5652147039371264/019f1500-2d23-727e-9230-507918367794.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJp36oF2wkQYYRw3VZLtDJT28",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "preschool"
    },
    {
      "id": "ec_45361de1d621c1d8389c6704",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5652147039371264",
      "source": "generator",
      "poi_name": "Katy Knowledge Beginnings",
      "poi_type": "Education",
      "poi_address": "6130 S Fry Rd, Katy, TX 77494, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5652147039371264/019f1501-c152-7253-aad9-4b2a5350adc8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1501-c152-7253-aad9-4b2a5350adc8",
        "storage_key": "property/5652147039371264/019f1501-c152-7253-aad9-4b2a5350adc8.webp",
        "width": 1000,
        "height": 750
      },
      "poi_business_url": "https://www.kindercare.com/our-centers/katy/tx/072126?utm_campaign=kc-lg&utm_source=yext&utm_medium=pro&utm_keyword=&utm_platform=&utm_matchtype=&utm_adgroupid=&utm_content=gmb&y_source=1_MzgwMzE1NS03MTUtbG9jYXRpb24ud2Vic2l0ZQ%3D%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=12047041350235076374&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "katy-knowledge-beginnings",
      "poi_latitude": "29.7137762",
      "poi_longitude": "-95.7662159",
      "poi_miles_from_property": "6.6 mi",
      "poi_walking_minutes": "2 hours 25 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 281-693-6556",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5652147039371264/019f1500-2d23-727e-9230-507918367794.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1500-2d23-727e-9230-507918367794",
        "storage_key": "property/5652147039371264/019f1500-2d23-727e-9230-507918367794.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJjTuJOvkgQYYRFjc0s0ewL6c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "preschool"
    },
    {
      "id": "ec_02d373c2713f871f1a9d0b30",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5652147039371264",
      "source": "generator",
      "poi_name": "Woodcreek Elementary School",
      "poi_type": "Education",
      "poi_address": "1155 Woodcreek Bend Ln, Katy, TX 77494, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5652147039371264/019f1501-c33a-7154-9758-6e21c0087197.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1501-c33a-7154-9758-6e21c0087197",
        "storage_key": "property/5652147039371264/019f1501-c33a-7154-9758-6e21c0087197.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://wce.katyisd.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3350407206426199768&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "woodcreek-elementary-school",
      "poi_latitude": "29.7666778",
      "poi_longitude": "-95.8330536",
      "poi_miles_from_property": "1.6 mi",
      "poi_walking_minutes": "36 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 281-234-0100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5652147039371264/019f1500-2d23-727e-9230-507918367794.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1500-2d23-727e-9230-507918367794",
        "storage_key": "property/5652147039371264/019f1500-2d23-727e-9230-507918367794.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJS7IqbAwkQYYR2EbxX5oJfy4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "ec_2475110ef66b6b65f1e9eec0",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5652147039371264",
      "source": "generator",
      "poi_name": "Woodcreek Junior High School",
      "poi_type": "Education",
      "poi_address": "1801 Woodcreek Bend Ln, Katy, TX 77494, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5652147039371264/019f1501-c344-7589-bdec-8df8531fa51d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1501-c344-7589-bdec-8df8531fa51d",
        "storage_key": "property/5652147039371264/019f1501-c344-7589-bdec-8df8531fa51d.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.katyisd.org/WCJH",
      "poi_directions_map_url": "https://maps.google.com/?cid=15506979208002389805&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "woodcreek-junior-high-school",
      "poi_latitude": "29.75989929999999",
      "poi_longitude": "-95.8306603",
      "poi_miles_from_property": "1.1 mi",
      "poi_walking_minutes": "25 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 281-234-0800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5652147039371264/019f1500-2d23-727e-9230-507918367794.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1500-2d23-727e-9230-507918367794",
        "storage_key": "property/5652147039371264/019f1500-2d23-727e-9230-507918367794.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJU3gIoA4kQYYRLcdZIG7bM9c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "ec_4c3bb08d44ad287c2428a648",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5652147039371264",
      "source": "generator",
      "poi_name": "Katy High School",
      "poi_type": "Education",
      "poi_address": "6331 Hwy Blvd, Katy, TX 77494, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5652147039371264/019f1501-c411-74dd-afeb-8bd8f7f06786.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1501-c411-74dd-afeb-8bd8f7f06786",
        "storage_key": "property/5652147039371264/019f1501-c411-74dd-afeb-8bd8f7f06786.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.katyisd.org/KHS",
      "poi_directions_map_url": "https://maps.google.com/?cid=14506368093129765827&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "katy-high-school",
      "poi_latitude": "29.7843661",
      "poi_longitude": "-95.8316489",
      "poi_miles_from_property": "3.0 mi",
      "poi_walking_minutes": "1 hour 8 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 281-237-6700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5652147039371264/019f1500-2d23-727e-9230-507918367794.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1500-2d23-727e-9230-507918367794",
        "storage_key": "property/5652147039371264/019f1500-2d23-727e-9230-507918367794.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ2XcJBzkkQYYRw3MPNOz4UMk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "ec_6e552388e60478c85266ca20",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5652147039371264",
      "source": "generator",
      "poi_name": "Seven Lakes High School",
      "poi_type": "Education",
      "poi_address": "9251 S Fry Rd, Katy, TX 77494, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5652147039371264/019f1501-c4c7-758a-afd4-97f0eeb3f836.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1501-c4c7-758a-afd4-97f0eeb3f836",
        "storage_key": "property/5652147039371264/019f1501-c4c7-758a-afd4-97f0eeb3f836.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.katyisd.org/SLHS",
      "poi_directions_map_url": "https://maps.google.com/?cid=10851475629554681671&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "seven-lakes-high-school",
      "poi_latitude": "29.7074544",
      "poi_longitude": "-95.8080054",
      "poi_miles_from_property": "5.6 mi",
      "poi_walking_minutes": "2 hours 3 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 281-237-2800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5652147039371264/019f1500-2d23-727e-9230-507918367794.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1500-2d23-727e-9230-507918367794",
        "storage_key": "property/5652147039371264/019f1500-2d23-727e-9230-507918367794.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJXQxhZoIhQYYRR0dqbJcvmJY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "ec_9e384fb388ded5a589e59d1d",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5652147039371264",
      "source": "generator",
      "poi_name": "Aristoi Classical Academy - District Office",
      "poi_type": "Education",
      "poi_address": "5610 Morton Rd, Katy, TX 77493, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5652147039371264/019f1501-c46b-76f5-b81e-d48a7b195e2c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1501-c46b-76f5-b81e-d48a7b195e2c",
        "storage_key": "property/5652147039371264/019f1501-c46b-76f5-b81e-d48a7b195e2c.webp",
        "width": 1067,
        "height": 825
      },
      "poi_business_url": "https://www.aristoiclassical.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10229193839335862696&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "aristoi-classical-academy---district-office",
      "poi_latitude": "29.8175594",
      "poi_longitude": "-95.816441",
      "poi_miles_from_property": "6.2 mi",
      "poi_walking_minutes": "2 hours 17 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 281-391-5003",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5652147039371264/019f1500-2d23-727e-9230-507918367794.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1500-2d23-727e-9230-507918367794",
        "storage_key": "property/5652147039371264/019f1500-2d23-727e-9230-507918367794.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJkW_hWN8lQYYRqHE6rJll9Y0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "ec_6f45b1e78e95f6b3d83fee87",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5652147039371264",
      "source": "generator",
      "poi_name": "Houston City College - Katy Campus",
      "poi_type": "Education",
      "poi_address": "22910 Colonial Pkwy, Katy, TX 77449, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5652147039371264/019f14ff-e146-7327-a546-6c085c3a359d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ff-e146-7327-a546-6c085c3a359d",
        "storage_key": "property/5652147039371264/019f14ff-e146-7327-a546-6c085c3a359d.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.hccs.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13237354447510935994&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "houston-city-college---katy-campus",
      "poi_latitude": "29.7945044",
      "poi_longitude": "-95.768164",
      "poi_miles_from_property": "7.2 mi",
      "poi_walking_minutes": "2 hours 40 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 713-718-5757",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5652147039371264/019f1500-2d23-727e-9230-507918367794.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1500-2d23-727e-9230-507918367794",
        "storage_key": "property/5652147039371264/019f1500-2d23-727e-9230-507918367794.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJOzBdKpLYQIYRupnTSbyHtLc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "ec_c818feac36bbf95d1c842932",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5652147039371264",
      "source": "generator",
      "poi_name": "Faith West Academy",
      "poi_type": "Education",
      "poi_address": "2225 Porter Rd, Katy, TX 77493, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5652147039371264/019f1501-c78f-75f8-a58e-c98a1aebd569.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1501-c78f-75f8-a58e-c98a1aebd569",
        "storage_key": "property/5652147039371264/019f1501-c78f-75f8-a58e-c98a1aebd569.webp",
        "width": 1024,
        "height": 683
      },
      "poi_business_url": "http://www.faithwest.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5207047178515817824&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "faith-west-academy",
      "poi_latitude": "29.804887",
      "poi_longitude": "-95.795",
      "poi_miles_from_property": "6.4 mi",
      "poi_walking_minutes": "2 hours 22 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 281-391-5683",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5652147039371264/019f1500-2d23-727e-9230-507918367794.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1500-2d23-727e-9230-507918367794",
        "storage_key": "property/5652147039371264/019f1500-2d23-727e-9230-507918367794.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJuQ_F7GAmQYYRYKUiHNIlQ0g",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "ec_ffc253332389ce7c88289675",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5652147039371264",
      "source": "generator",
      "poi_name": "Flix Brewhouse Katy",
      "poi_type": "Entertainment",
      "poi_address": "2707 Commercial Center Blvd Ste K-100, Katy, TX 77494, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5652147039371264/019f1501-c971-7320-a28e-5428a1c70ddb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1501-c971-7320-a28e-5428a1c70ddb",
        "storage_key": "property/5652147039371264/019f1501-c971-7320-a28e-5428a1c70ddb.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://flixbrewhouse.com/theaters/g0fx5-flix-brewhouse-katy/?utm_source=google&utm_medium=organic&utm_campaign=gbp_location&utm_content=%3Ccity%3E",
      "poi_directions_map_url": "https://maps.google.com/?cid=3457571188783616312&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "flix-brewhouse-katy",
      "poi_latitude": "29.7403246",
      "poi_longitude": "-95.7740051",
      "poi_miles_from_property": "5.8 mi",
      "poi_walking_minutes": "2 hours 8 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 346-615-2800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5652147039371264/019f1501-ff63-7231-bc62-26af9c4f5755.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1501-ff63-7231-bc62-26af9c4f5755",
        "storage_key": "property/5652147039371264/019f1501-ff63-7231-bc62-26af9c4f5755.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJsVGxf7whQYYROJESXa3C-y8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "movie_theater"
    },
    {
      "id": "ec_ad140e0a8fc81934169d9774",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5652147039371264",
      "source": "generator",
      "poi_name": "AMC Katy Mills 20",
      "poi_type": "Entertainment",
      "poi_address": "5000 Katy Mills Cir #131, Katy, TX 77494, USA",
      "poi_short_description": "Local chain for movies featuring arcade games, recliner chairs and a soda fountain.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5652147039371264/019f1501-c929-7311-ad61-13b4c027b73d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1501-c929-7311-ad61-13b4c027b73d",
        "storage_key": "property/5652147039371264/019f1501-c929-7311-ad61-13b4c027b73d.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.amctheatres.com/movie-theatres/houston/amc-katy-mills-20?utm_medium=organic&utm_source=google&utm_campaign=local",
      "poi_directions_map_url": "https://maps.google.com/?cid=15478905560829687672&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "amc-katy-mills-20",
      "poi_latitude": "29.7724542",
      "poi_longitude": "-95.8096915",
      "poi_miles_from_property": "5.5 mi",
      "poi_walking_minutes": "2 hours 2 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 281-644-4262",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5652147039371264/019f1501-ff63-7231-bc62-26af9c4f5755.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1501-ff63-7231-bc62-26af9c4f5755",
        "storage_key": "property/5652147039371264/019f1501-ff63-7231-bc62-26af9c4f5755.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJX7OEjKEmQYYReHcSyZge0NY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "movie_theater"
    },
    {
      "id": "ec_6b87a373d87ae2f5e4cd1b07",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5652147039371264",
      "source": "generator",
      "poi_name": "Typhoon Texas Waterpark Houston",
      "poi_type": "Entertainment",
      "poi_address": "555 Katy Fort Bend Rd, Katy, TX 77494, USA",
      "poi_short_description": "Spacious, playful place with serpentine water slides & a lazy river for tubing, plus eateries.",
      "poi_long_description": "Spacious, playful place with serpentine water slides & a lazy river for tubing, plus eateries.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5652147039371264/019f14ff-ddb5-77b4-b6d4-d1a65e0ca468.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ff-ddb5-77b4-b6d4-d1a65e0ca468",
        "storage_key": "property/5652147039371264/019f14ff-ddb5-77b4-b6d4-d1a65e0ca468.webp",
        "width": 1080,
        "height": 608
      },
      "poi_business_url": "https://www.typhoontexas.com/houston",
      "poi_directions_map_url": "https://maps.google.com/?cid=17151496343800091588&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "typhoon-texas-waterpark-houston",
      "poi_latitude": "29.7794714",
      "poi_longitude": "-95.8035959",
      "poi_miles_from_property": "5.1 mi",
      "poi_walking_minutes": "1 hour 53 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 832-426-7071",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5652147039371264/019f1500-2d79-729c-8bca-b8c9604f9307.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1500-2d79-729c-8bca-b8c9604f9307",
        "storage_key": "property/5652147039371264/019f1500-2d79-729c-8bca-b8c9604f9307.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJj9qVvZcmQYYRxJOdWg1bBu4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "water_park"
    },
    {
      "id": "ec_24613fc4215ef1953af6203e",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5652147039371264",
      "source": "generator",
      "poi_name": "LaCenterra at Cinco Ranch",
      "poi_type": "Entertainment",
      "poi_address": "23501 Cinco Ranch Blvd, Katy, TX 77494, USA",
      "poi_short_description": "Outdoor shopping center with business offices, clothing, footwear, beauty & gift shops, plus dining.",
      "poi_long_description": "Outdoor shopping center with business offices, clothing, footwear, beauty & gift shops, plus dining.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5652147039371264/019f14ff-cdae-70ac-8787-b41bd5b49eb1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ff-cdae-70ac-8787-b41bd5b49eb1",
        "storage_key": "property/5652147039371264/019f14ff-cdae-70ac-8787-b41bd5b49eb1.webp",
        "width": 750,
        "height": 421
      },
      "poi_business_url": "https://lacenterra.com/?utm_source=gmb&utm_medium=Yext",
      "poi_directions_map_url": "https://maps.google.com/?cid=17500870136583917237&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lacenterra-at-cinco-ranch",
      "poi_latitude": "29.7429973",
      "poi_longitude": "-95.7750596",
      "poi_miles_from_property": "5.8 mi",
      "poi_walking_minutes": "2 hours 8 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 281-395-5533",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5652147039371264/019f1500-2d22-7457-b0bb-a8ecc36cd5e6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1500-2d22-7457-b0bb-a8ecc36cd5e6",
        "storage_key": "property/5652147039371264/019f1500-2d22-7457-b0bb-a8ecc36cd5e6.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ-W5CySchQYYRtY5TZ6qU3_I",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "ec_3256f318dff09f7870136714",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5652147039371264",
      "source": "generator",
      "poi_name": "Leonard E. Merrell Center",
      "poi_type": "Entertainment",
      "poi_address": "6301 S Stadium Ln, Katy, TX 77494, USA",
      "poi_short_description": "Multi-purpose event venue, often home to graduation ceremonies and other functions.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5652147039371264/019f1500-0260-779b-96de-1640cb06d049.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1500-0260-779b-96de-1640cb06d049",
        "storage_key": "property/5652147039371264/019f1500-0260-779b-96de-1640cb06d049.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.merrellcenter.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16426612715258916416&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "leonard-e-merrell-center",
      "poi_latitude": "29.7798456",
      "poi_longitude": "-95.832647",
      "poi_miles_from_property": "2.8 mi",
      "poi_walking_minutes": "1 hour 2 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 281-396-2562",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5652147039371264/019f1500-2d79-729c-8bca-b8c9604f9307.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1500-2d79-729c-8bca-b8c9604f9307",
        "storage_key": "property/5652147039371264/019f1500-2d79-729c-8bca-b8c9604f9307.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ0_8apD4kQYYRQC7sizsN9-M",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "arena"
    },
    {
      "id": "ec_620c63f9697a3a01edc976f6",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5652147039371264",
      "source": "generator",
      "poi_name": "The Wildcatter Saloon",
      "poi_type": "Entertainment",
      "poi_address": "26913 Katy Fwy, Katy, TX 77494, USA",
      "poi_short_description": "Beer & pub grub in a rustic setting with pool tables, a deck & live blues & other music.",
      "poi_long_description": "Beer & pub grub in a rustic setting with pool tables, a deck & live blues & other music.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5652147039371264/019f1501-cb14-71af-9f1a-6da29be5b550.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1501-cb14-71af-9f1a-6da29be5b550",
        "storage_key": "property/5652147039371264/019f1501-cb14-71af-9f1a-6da29be5b550.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.wildcattersaloon.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13993481171269508343&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-wildcatter-saloon",
      "poi_latitude": "29.7740239",
      "poi_longitude": "-95.84284",
      "poi_miles_from_property": "3.3 mi",
      "poi_walking_minutes": "1 hour 12 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 281-392-2337",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5652147039371264/019f1501-ff7f-767b-b368-4731edfeaf84.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1501-ff7f-767b-b368-4731edfeaf84",
        "storage_key": "property/5652147039371264/019f1501-ff7f-767b-b368-4731edfeaf84.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJIfI6sWkkQYYR99yiEPzUMsI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bar"
    },
    {
      "id": "ec_3295a6413b14dbe0a83dd9b8",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5652147039371264",
      "source": "generator",
      "poi_name": "Katy Vibes",
      "poi_type": "Entertainment",
      "poi_address": "24757 Katy Fwy, Katy, TX 77494, USA",
      "poi_short_description": "Vibrant restaurant & bar featuring homestyle cooking & crawfish specialties, plus live music.",
      "poi_long_description": "Vibrant restaurant & bar featuring homestyle cooking & crawfish specialties, plus live music.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5652147039371264/019f1501-d216-7146-92e8-ef3806d33343.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1501-d216-7146-92e8-ef3806d33343",
        "storage_key": "property/5652147039371264/019f1501-d216-7146-92e8-ef3806d33343.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://katyvibes.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16223769935608810711&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "katy-vibes",
      "poi_latitude": "29.7843892",
      "poi_longitude": "-95.7993519",
      "poi_miles_from_property": "5.0 mi",
      "poi_walking_minutes": "1 hour 52 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 832-437-2807",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5652147039371264/019f1501-ff7f-767b-b368-4731edfeaf84.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1501-ff7f-767b-b368-4731edfeaf84",
        "storage_key": "property/5652147039371264/019f1501-ff7f-767b-b368-4731edfeaf84.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJm-or0dknQYYR1wygmcxoJuE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bar_and_grill"
    },
    {
      "id": "ec_9cddbb33eba36c330e6fd432",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5652147039371264",
      "source": "generator",
      "poi_name": "Main Event Katy",
      "poi_type": "Entertainment",
      "poi_address": "24401 Katy Fwy, Katy, TX 77494, USA",
      "poi_short_description": "Laid-back chain, part of Katy Ranch Crossing, featuring bowling alleys and laser tag arenas.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5652147039371264/019f14ff-cd3a-770a-9efc-e42b78487e42.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ff-cd3a-770a-9efc-e42b78487e42",
        "storage_key": "property/5652147039371264/019f14ff-cd3a-770a-9efc-e42b78487e42.webp",
        "width": 1080,
        "height": 608
      },
      "poi_business_url": "http://www.mainevent.com/locations/texas/katy",
      "poi_directions_map_url": "https://maps.google.com/?cid=441350998554445187&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "main-event-katy",
      "poi_latitude": "29.7833217",
      "poi_longitude": "-95.7922727",
      "poi_miles_from_property": "5.5 mi",
      "poi_walking_minutes": "2 hours 2 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 281-394-4800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5652147039371264/019f1500-2d10-70a9-8127-37b32506d702.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1500-2d10-70a9-8127-37b32506d702",
        "storage_key": "property/5652147039371264/019f1500-2d10-70a9-8127-37b32506d702.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJxXz5vO4mQYYRgwUaEmX-HwY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "ec_a587a5604b75d7b34675ec56",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5652147039371264",
      "source": "generator",
      "poi_name": "MKT Railroad Museum",
      "poi_type": "Entertainment",
      "poi_address": "5615 1st St, Katy, TX 77493, USA",
      "poi_short_description": "Historic train station with life-sized exhibits & a red caboose car displayed in a park setting.",
      "poi_long_description": "Historic train station with life-sized exhibits & a red caboose car displayed in a park setting.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5652147039371264/019f1501-ce99-72c2-b575-5fc2760bbb8d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1501-ce99-72c2-b575-5fc2760bbb8d",
        "storage_key": "property/5652147039371264/019f1501-ce99-72c2-b575-5fc2760bbb8d.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.katyheritagesociety.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13160350468534062150&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mkt-railroad-museum",
      "poi_latitude": "29.786267",
      "poi_longitude": "-95.8218458",
      "poi_miles_from_property": "3.6 mi",
      "poi_walking_minutes": "1 hour 21 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 281-391-8400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5652147039371264/019f1501-ff84-74c4-997b-c1ea3fd2b436.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1501-ff84-74c4-997b-c1ea3fd2b436",
        "storage_key": "property/5652147039371264/019f1501-ff84-74c4-997b-c1ea3fd2b436.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJX5DYCSUkQYYRRkyeTAb1orY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "ec_1781f1a36e22f6acf556ca12",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5652147039371264",
      "source": "generator",
      "poi_name": "Kanga's Indoor Playcenter and Cafe, Katy",
      "poi_type": "Entertainment",
      "poi_address": "610 Katy Fort Bend Rd, Katy, TX 77494, USA",
      "poi_short_description": "Playground for kids 1-11 including ball pits, arcade games and a rock climbing wall, plus a cafe.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5652147039371264/019f1501-ce9c-768c-9fd8-4643c9798100.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1501-ce9c-768c-9fd8-4643c9798100",
        "storage_key": "property/5652147039371264/019f1501-ce9c-768c-9fd8-4643c9798100.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://katy.kangasplaycenter.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11891437678932730592&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kangas-indoor-playcenter-and-cafe-katy",
      "poi_latitude": "29.7796645",
      "poi_longitude": "-95.8008087",
      "poi_miles_from_property": "5.2 mi",
      "poi_walking_minutes": "1 hour 56 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 281-645-0980",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5652147039371264/019f1500-2d79-729c-8bca-b8c9604f9307.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1500-2d79-729c-8bca-b8c9604f9307",
        "storage_key": "property/5652147039371264/019f1500-2d79-729c-8bca-b8c9604f9307.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJGzMZhKsnQYYR4CJ7wZDfBqU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "indoor_playground"
    },
    {
      "id": "ec_96a7537ed13f25deda69e1d6",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5652147039371264",
      "source": "generator",
      "poi_name": "Memorial Hermann Katy Hospital",
      "poi_type": "Health and Wellness",
      "poi_address": "23900 Katy Fwy, Katy, TX 77494, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5652147039371264/019f1500-08b1-75f8-9673-d388d3ab77af.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1500-08b1-75f8-9673-d388d3ab77af",
        "storage_key": "property/5652147039371264/019f1500-08b1-75f8-9673-d388d3ab77af.webp",
        "width": 800,
        "height": 450
      },
      "poi_business_url": "https://memorialhermann.org/locations/katy?utm_campaign=reputation-management&utm_segment=gmb_location-listing&utm_source=yext&utm_medium=organic-search",
      "poi_directions_map_url": "https://maps.google.com/?cid=75134535897600095&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "memorial-hermann-katy-hospital",
      "poi_latitude": "29.7875539",
      "poi_longitude": "-95.7864102",
      "poi_miles_from_property": "5.8 mi",
      "poi_walking_minutes": "2 hours 9 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 281-644-7000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5652147039371264/019f1500-2d22-7457-b0bb-acf9127de84e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1500-2d22-7457-b0bb-acf9127de84e",
        "storage_key": "property/5652147039371264/019f1500-2d22-7457-b0bb-acf9127de84e.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJq6qqqrogQYYRX1CKWnbuCgE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "general_hospital"
    },
    {
      "id": "ec_369f92d74bbb55d7dedc8e9a",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5652147039371264",
      "source": "generator",
      "poi_name": "CareNow Urgent Care - Katy",
      "poi_type": "Health and Wellness",
      "poi_address": "6501 S Fry Rd, Katy, TX 77494, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5652147039371264/019f1501-cd82-7775-8fc3-c44be3d0e339.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1501-cd82-7775-8fc3-c44be3d0e339",
        "storage_key": "property/5652147039371264/019f1501-cd82-7775-8fc3-c44be3d0e339.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.carenow.com/locations/houston/katy?utm_campaign=corp_listings_mgmt&utm_source=google&utm_medium=business_listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=5471092845589844102&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "carenow-urgent-care---katy",
      "poi_latitude": "29.712926",
      "poi_longitude": "-95.7705562",
      "poi_miles_from_property": "6.3 mi",
      "poi_walking_minutes": "2 hours 20 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 832-260-0670",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5652147039371264/019f1500-2d79-729c-8bca-b8c9604f9307.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1500-2d79-729c-8bca-b8c9604f9307",
        "storage_key": "property/5652147039371264/019f1500-2d79-729c-8bca-b8c9604f9307.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJRxhYRf4gQYYRhlCQuvQ57Us",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "ec_6fae77396ac9842bdab84e21",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5652147039371264",
      "source": "generator",
      "poi_name": "Preferred Urgent Care Katy",
      "poi_type": "Health and Wellness",
      "poi_address": "1450 W Grand Pkwy S Ste m, Katy, TX 77494, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5652147039371264/019f1501-d139-71cd-8b06-50ae4faa6fc9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1501-d139-71cd-8b06-50ae4faa6fc9",
        "storage_key": "property/5652147039371264/019f1501-d139-71cd-8b06-50ae4faa6fc9.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.preferredurgentcare.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5073626357005072645&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "preferred-urgent-care-katy",
      "poi_latitude": "29.7593485",
      "poi_longitude": "-95.77813700000002",
      "poi_miles_from_property": "5.9 mi",
      "poi_walking_minutes": "2 hours 10 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 346-591-8346",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5652147039371264/019f1500-2d79-729c-8bca-b8c9604f9307.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1500-2d79-729c-8bca-b8c9604f9307",
        "storage_key": "property/5652147039371264/019f1500-2d79-729c-8bca-b8c9604f9307.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJK-xYnNMmQYYRBblYXEokaUY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "ec_af6312bc7c55f4dd19c2f7f2",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5652147039371264",
      "source": "generator",
      "poi_name": "Texas Children's Urgent Care Cinco Ranch",
      "poi_type": "Health and Wellness",
      "poi_address": "9727 Spring Green Blvd Suite 900 Suite 900, Katy, TX 77494, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5652147039371264/019f1501-d6b8-71ea-bdf9-299052318ebd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1501-d6b8-71ea-bdf9-299052318ebd",
        "storage_key": "property/5652147039371264/019f1501-d6b8-71ea-bdf9-299052318ebd.webp",
        "width": 1280,
        "height": 852
      },
      "poi_business_url": "https://www.texaschildrens.org/locations/texas-childrens-urgent-care/cinco-ranch",
      "poi_directions_map_url": "https://maps.google.com/?cid=13944084539362939802&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "texas-childrens-urgent-care-cinco-ranch",
      "poi_latitude": "29.7030078",
      "poi_longitude": "-95.8157361",
      "poi_miles_from_property": "5.3 mi",
      "poi_walking_minutes": "1 hour 58 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 281-789-6300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5652147039371264/019f1500-2d79-729c-8bca-b8c9604f9307.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1500-2d79-729c-8bca-b8c9604f9307",
        "storage_key": "property/5652147039371264/019f1500-2d79-729c-8bca-b8c9604f9307.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJqQeqiyoiQYYRmpO-dgJXg8E",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "ec_c759b63ba083493d6b36936e",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5652147039371264",
      "source": "generator",
      "poi_name": "Kroger Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "1550 W Grand Pkwy S, Katy, TX 77494, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5652147039371264/019f1501-ce9c-768c-9fd8-4858b7668c92.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1501-ce9c-768c-9fd8-4858b7668c92",
        "storage_key": "property/5652147039371264/019f1501-ce9c-768c-9fd8-4858b7668c92.webp",
        "width": 796,
        "height": 503
      },
      "poi_business_url": "https://www.kroger.com/rx/pharmacy/details/034/00733?cid=loc_03400733P_gmb",
      "poi_directions_map_url": "https://maps.google.com/?cid=6822576329664366707&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kroger-pharmacy",
      "poi_latitude": "29.7579212",
      "poi_longitude": "-95.7783683",
      "poi_miles_from_property": "5.8 mi",
      "poi_walking_minutes": "2 hours 7 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 281-693-0606",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5652147039371264/019f1501-ff63-7231-bc62-1c06cc85817c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1501-ff63-7231-bc62-1c06cc85817c",
        "storage_key": "property/5652147039371264/019f1501-ff63-7231-bc62-1c06cc85817c.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJR7NMetMmQYYRcwiiNgaprl4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "ec_69a2ad7a3eb0a77756144499",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5652147039371264",
      "source": "generator",
      "poi_name": "CVS Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "602 W Grand Pkwy S, Katy, TX 77494, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5652147039371264/019f1501-d5f0-70bc-9970-bcd98b3debea.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1501-d5f0-70bc-9970-bcd98b3debea",
        "storage_key": "property/5652147039371264/019f1501-d5f0-70bc-9970-bcd98b3debea.webp",
        "width": 1100,
        "height": 743
      },
      "poi_business_url": "https://www.cvs.com/store-locator/katy-tx-pharmacies/602-w-grand-pkwy-south-corner-of-grand-parkway-katy-tx-77494/storeid=6747?WT.mc_id=LS_GOOGLE_RX_6747",
      "poi_directions_map_url": "https://maps.google.com/?cid=10317749345234479743&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cvs-pharmacy",
      "poi_latitude": "29.7715979",
      "poi_longitude": "-95.7783342",
      "poi_miles_from_property": "6.9 mi",
      "poi_walking_minutes": "2 hours 31 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 281-392-3808",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5652147039371264/019f1501-ff63-7231-bc62-1c06cc85817c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1501-ff63-7231-bc62-1c06cc85817c",
        "storage_key": "property/5652147039371264/019f1501-ff63-7231-bc62-1c06cc85817c.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJTfL16dsmQYYRf2o4HF0CMI8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "ec_7e626d7ed991c0915d7c424f",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5652147039371264",
      "source": "generator",
      "poi_name": "Walgreens Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "6802 S Fry Rd, Katy, TX 77494, USA",
      "poi_short_description": "Department of the Walgreens chain providing prescription medications & other health-related items.",
      "poi_long_description": "Department of the Walgreens chain providing prescription medications & other health-related items.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5652147039371264/019f1501-d9f8-7012-808f-ea26f9d53869.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1501-d9f8-7012-808f-ea26f9d53869",
        "storage_key": "property/5652147039371264/019f1501-d9f8-7012-808f-ea26f9d53869.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.walgreens.com/locator/walgreens-6802+s+fry+rd-katy-tx-77494/id=7491",
      "poi_directions_map_url": "https://maps.google.com/?cid=8300787744180104381&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walgreens-pharmacy",
      "poi_latitude": "29.71494819999999",
      "poi_longitude": "-95.7744339",
      "poi_miles_from_property": "6.1 mi",
      "poi_walking_minutes": "2 hours 13 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 281-392-0077",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5652147039371264/019f1501-ff63-7231-bc62-1c06cc85817c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1501-ff63-7231-bc62-1c06cc85817c",
        "storage_key": "property/5652147039371264/019f1501-ff63-7231-bc62-1c06cc85817c.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJwX36gwEhQYYRvWzFT3lSMnM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "ec_d1bcbd708c48eb1915c8c432",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5652147039371264",
      "source": "generator",
      "poi_name": "Life Time",
      "poi_type": "Health and Wellness",
      "poi_address": "23211 Cinco Ranch Blvd, Katy, TX 77494, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5652147039371264/019f14ff-e9ce-76db-b7d1-aec91f64ef17.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ff-e9ce-76db-b7d1-aec91f64ef17",
        "storage_key": "property/5652147039371264/019f14ff-e9ce-76db-b7d1-aec91f64ef17.webp",
        "width": 640,
        "height": 640
      },
      "poi_business_url": "https://www.lifetime.life/locations/tx/cinco-ranch.html?utm_source=google&utm_medium=local&utm_campaign=google-local-club",
      "poi_directions_map_url": "https://maps.google.com/?cid=10149644263920371599&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "life-time",
      "poi_latitude": "29.7421448",
      "poi_longitude": "-95.7705562",
      "poi_miles_from_property": "6.2 mi",
      "poi_walking_minutes": "2 hours 18 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 281-644-5300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5652147039371264/019f1500-2d79-729c-8bca-b8c9604f9307.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1500-2d79-729c-8bca-b8c9604f9307",
        "storage_key": "property/5652147039371264/019f1500-2d79-729c-8bca-b8c9604f9307.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJD6eeQ9ggQYYRjweO067H2ow",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "ec_41003f3d841db9b7f4b8c53b",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5652147039371264",
      "source": "generator",
      "poi_name": "Monty Ballard YMCA at Cinco Ranch",
      "poi_type": "Health and Wellness",
      "poi_address": "22807 Westheimer Pkwy, Katy, TX 77494, USA",
      "poi_short_description": "Community-focused nonprofit established in 1844 with recreational programs & services for all ages.",
      "poi_long_description": "Community-focused nonprofit established in 1844 with recreational programs & services for all ages.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5652147039371264/019f1501-d788-757c-987d-284b99df2c14.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1501-d788-757c-987d-284b99df2c14",
        "storage_key": "property/5652147039371264/019f1501-d788-757c-987d-284b99df2c14.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://ymcahouston.org/locations/monty-ballard-ymca-cinco-ranch",
      "poi_directions_map_url": "https://maps.google.com/?cid=8174883696080940208&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "monty-ballard-ymca-at-cinco-ranch",
      "poi_latitude": "29.733696",
      "poi_longitude": "-95.765117",
      "poi_miles_from_property": "6.3 mi",
      "poi_walking_minutes": "2 hours 19 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 281-392-5055",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5652147039371264/019f1500-2d79-729c-8bca-b8c9604f9307.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1500-2d79-729c-8bca-b8c9604f9307",
        "storage_key": "property/5652147039371264/019f1500-2d79-729c-8bca-b8c9604f9307.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJR_ETV6wmQYYRsGwJwWgFc3E",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "non_profit_organization"
    },
    {
      "id": "ec_d88babf5b2f3ec3e4b4a8166",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5652147039371264",
      "source": "generator",
      "poi_name": "ALEOLI Me Time Studio",
      "poi_type": "Health and Wellness",
      "poi_address": "23402 Kingsland Blvd #500, Katy, TX 77494, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5652147039371264/019f1501-d978-70e5-b9ca-27595bc2887c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1501-d978-70e5-b9ca-27595bc2887c",
        "storage_key": "property/5652147039371264/019f1501-d978-70e5-b9ca-27595bc2887c.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://aleolimetime.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13512124433467328401&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "aleoli-me-time-studio",
      "poi_latitude": "29.7726514",
      "poi_longitude": "-95.7797068",
      "poi_miles_from_property": "7.0 mi",
      "poi_walking_minutes": "2 hours 35 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 832-469-3491",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5652147039371264/019f1501-ff62-7589-a58a-136bfe210947.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1501-ff62-7589-a58a-136bfe210947",
        "storage_key": "property/5652147039371264/019f1501-ff62-7589-a58a-136bfe210947.webp",
        "width": 192,
        "height": 144
      },
      "poi_google_place_id": "ChIJ3-XwXDonQYYRkUey-ZS1hLs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "coffee_shop"
    },
    {
      "id": "ec_c8aa0318b929f443fd0bd631",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5652147039371264",
      "source": "generator",
      "poi_name": "Cross Creek Ranch Canine Commons",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "5727 Flewellen Oaks Lane, Fulshear, TX 77441, USA",
      "poi_short_description": "Shady, well-rated dog park featuring separate areas for small and large dogs, plus water stations.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5652147039371264/019f1501-d9d5-70cb-b304-f8f926ed05c2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1501-d9d5-70cb-b304-f8f926ed05c2",
        "storage_key": "property/5652147039371264/019f1501-d9d5-70cb-b304-f8f926ed05c2.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.crosscreektexas.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8748536242077069341&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cross-creek-ranch-canine-commons",
      "poi_latitude": "29.7041759",
      "poi_longitude": "-95.8497959",
      "poi_miles_from_property": "5.9 mi",
      "poi_walking_minutes": "2 hours 9 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5652147039371264/019f1500-2d78-77db-b8d5-46fe84d8ec78.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1500-2d78-77db-b8d5-46fe84d8ec78",
        "storage_key": "property/5652147039371264/019f1500-2d78-77db-b8d5-46fe84d8ec78.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJkc-ZElMiQYYRHXCiRVwLaXk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "dog_park"
    },
    {
      "id": "ec_cd2b19c3c4e8ec1bb4dc8adf",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5652147039371264",
      "source": "generator",
      "poi_name": "Camp Flewellen",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "4623 Morgans Spur Dr, Fulshear, TX 77441, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5652147039371264/019f1501-dca6-727e-8b92-1d7b09a1f670.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1501-dca6-727e-8b92-1d7b09a1f670",
        "storage_key": "property/5652147039371264/019f1501-dca6-727e-8b92-1d7b09a1f670.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=13071524221285196760&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "camp-flewellen",
      "poi_latitude": "29.71655489999999",
      "poi_longitude": "-95.8709411",
      "poi_miles_from_property": "5.7 mi",
      "poi_walking_minutes": "2 hours 5 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5652147039371264/019f1500-2d78-77db-b8d5-46fe84d8ec78.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1500-2d78-77db-b8d5-46fe84d8ec78",
        "storage_key": "property/5652147039371264/019f1500-2d78-77db-b8d5-46fe84d8ec78.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJC2g93zMjQYYR2GOe-gViZ7U",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_a758cb68dc5e8241e02ca3f6",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5652147039371264",
      "source": "generator",
      "poi_name": "FB MUD 35 Dog Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "8949 S Fry Rd, Katy, TX 77494, USA",
      "poi_short_description": "Small park featuring a separate area for small dogs plus benches and shady spots.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5652147039371264/019f1501-def1-748d-8eb7-a2b5b321fb9b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1501-def1-748d-8eb7-a2b5b321fb9b",
        "storage_key": "property/5652147039371264/019f1501-def1-748d-8eb7-a2b5b321fb9b.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=461084010058080676&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "fb-mud-35-dog-park",
      "poi_latitude": "29.7120269",
      "poi_longitude": "-95.8047194",
      "poi_miles_from_property": "5.0 mi",
      "poi_walking_minutes": "1 hour 51 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 713-623-4531",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5652147039371264/019f1500-2d78-77db-b8d5-46fe84d8ec78.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1500-2d78-77db-b8d5-46fe84d8ec78",
        "storage_key": "property/5652147039371264/019f1500-2d78-77db-b8d5-46fe84d8ec78.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJg8i6CCEhQYYRpOEf13YZZgY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "dog_park"
    },
    {
      "id": "ec_498f8f249697f14a5222706e",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5652147039371264",
      "source": "generator",
      "poi_name": "Fort Bend M.U.D. 124 Recreation Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "2211 Cactus Bloom Ln, Katy, TX 77494, USA",
      "poi_short_description": "Neighborhood recreational park offering a children's playground & covered picnic area.",
      "poi_long_description": "Neighborhood recreational park offering a children's playground & covered picnic area.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5652147039371264/019f1501-df4b-773e-8442-f76daeed6dbc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1501-df4b-773e-8442-f76daeed6dbc",
        "storage_key": "property/5652147039371264/019f1501-df4b-773e-8442-f76daeed6dbc.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.fortbendcountytx.gov/your-county/recreation",
      "poi_directions_map_url": "https://maps.google.com/?cid=9974695247039467787&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "fort-bend-mud-124-recreation-park",
      "poi_latitude": "29.7527925",
      "poi_longitude": "-95.7830543",
      "poi_miles_from_property": "5.3 mi",
      "poi_walking_minutes": "1 hour 57 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 713-860-6400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5652147039371264/019f1500-2d78-77db-b8d5-46fe84d8ec78.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1500-2d78-77db-b8d5-46fe84d8ec78",
        "storage_key": "property/5652147039371264/019f1500-2d78-77db-b8d5-46fe84d8ec78.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJm1S-hjIhQYYRC5GQnno8bYo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_f0a88aca5fe5ea359e4dddfb",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5652147039371264",
      "source": "generator",
      "poi_name": "Central Green – Willow Fork Drainage District",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "23501 Cinco Ranch Blvd, Katy, TX 77494, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5652147039371264/019f1501-dfc2-75ed-ac3e-2c6a3032f790.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1501-dfc2-75ed-ac3e-2c6a3032f790",
        "storage_key": "property/5652147039371264/019f1501-dfc2-75ed-ac3e-2c6a3032f790.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.centralgreenpark.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11114343322930341385&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "central-green--willow-fork-drainage-district",
      "poi_latitude": "29.741424",
      "poi_longitude": "-95.7749041",
      "poi_miles_from_property": "5.8 mi",
      "poi_walking_minutes": "2 hours 7 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5652147039371264/019f1500-2d78-77db-b8d5-46fe84d8ec78.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1500-2d78-77db-b8d5-46fe84d8ec78",
        "storage_key": "property/5652147039371264/019f1500-2d78-77db-b8d5-46fe84d8ec78.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ7xwtPCYhQYYRCWb_ql0UPpo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_30a4ca4f4b83fc95e2ba142a",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5652147039371264",
      "source": "generator",
      "poi_name": "Willow Fork Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "23440 Cinco Ranch Blvd, Katy, TX 77494, USA",
      "poi_short_description": "Clean park featuring a playground and a butterfly garden, plus disc golf courses and picnic facilities.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5652147039371264/019f1500-1524-7052-90be-dfc963ebd649.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1500-1524-7052-90be-dfc963ebd649",
        "storage_key": "property/5652147039371264/019f1500-1524-7052-90be-dfc963ebd649.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.willowforkdrainagedistrict.com/parks-trails/willow-fork-park/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6700229735960575357&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "willow-fork-park",
      "poi_latitude": "29.7506138",
      "poi_longitude": "-95.7767014",
      "poi_miles_from_property": "5.7 mi",
      "poi_walking_minutes": "2 hours 5 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5652147039371264/019f1500-2d78-77db-b8d5-46fe84d8ec78.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1500-2d78-77db-b8d5-46fe84d8ec78",
        "storage_key": "property/5652147039371264/019f1500-2d78-77db-b8d5-46fe84d8ec78.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJe2VBWS0hQYYRfX1wDXL_-1w",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_e61d95c9763d2fd150e71c7c",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5652147039371264",
      "source": "generator",
      "poi_name": "Cinco Ranch Lake House",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "25202 Springwood Lake Dr, Katy, TX 77494, USA",
      "poi_short_description": "Family-friendly area, spot and venue for activities, parties, events and weddings, along with a lake.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5652147039371264/019f1501-e1bb-717e-8764-bde3eeb47c4e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1501-e1bb-717e-8764-bde3eeb47c4e",
        "storage_key": "property/5652147039371264/019f1501-e1bb-717e-8764-bde3eeb47c4e.webp",
        "width": 1024,
        "height": 681
      },
      "poi_business_url": "http://www.mycincoranch.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11780549650074116980&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cinco-ranch-lake-house",
      "poi_latitude": "29.7098301",
      "poi_longitude": "-95.8149369",
      "poi_miles_from_property": "5.0 mi",
      "poi_walking_minutes": "1 hour 50 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 281-394-7195",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5652147039371264/019f1500-2d79-729c-8bca-b8c9604f9307.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1500-2d79-729c-8bca-b8c9604f9307",
        "storage_key": "property/5652147039371264/019f1500-2d79-729c-8bca-b8c9604f9307.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ_2egZdUjQYYRdCOFn33rfKM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "community_center"
    },
    {
      "id": "ec_2f0eeccbab2a3f1b85279e2b",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5652147039371264",
      "source": "generator",
      "poi_name": "City of Katy Off-Leash Dog Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "5414 Franz Rd, Katy, TX 77493, USA",
      "poi_short_description": "Covering 14 acres, this off-leash dog park has grassy fields & fountains & hosts annual events.",
      "poi_long_description": "Covering 14 acres, this off-leash dog park has grassy fields & fountains & hosts annual events.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5652147039371264/019f1501-e727-726a-bc0d-ac37dcd20646.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1501-e727-726a-bc0d-ac37dcd20646",
        "storage_key": "property/5652147039371264/019f1501-e727-726a-bc0d-ac37dcd20646.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.cityofkaty.com/Home/Components/FacilityDirectory/FacilityDirectory/6/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16026561768731967906&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "city-of-katy-off-leash-dog-park",
      "poi_latitude": "29.8025755",
      "poi_longitude": "-95.8178528",
      "poi_miles_from_property": "5.0 mi",
      "poi_walking_minutes": "1 hour 51 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 281-391-4840",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5652147039371264/019f1500-2d78-77db-b8d5-46fe84d8ec78.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1500-2d78-77db-b8d5-46fe84d8ec78",
        "storage_key": "property/5652147039371264/019f1500-2d78-77db-b8d5-46fe84d8ec78.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJs2iBXNQlQYYRogEgLATJad4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "dog_park"
    },
    {
      "id": "ec_533e6eebf39caa2d147d6a8a",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5652147039371264",
      "source": "generator",
      "poi_name": "Millie Bush Dog Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "16101 Westheimer Rd, Houston, TX 77082, USA",
      "poi_short_description": "Separate areas for small & large dogs, plus a walking trail, ponds & a dog shower.",
      "poi_long_description": "Separate areas for small & large dogs, plus a walking trail, ponds & a dog shower.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5652147039371264/019f1501-e61f-75fe-a7f5-bf95b7a63e88.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1501-e61f-75fe-a7f5-bf95b7a63e88",
        "storage_key": "property/5652147039371264/019f1501-e61f-75fe-a7f5-bf95b7a63e88.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "https://cp4.harriscountytx.gov/dogparks",
      "poi_directions_map_url": "https://maps.google.com/?cid=14209373870009034643&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "millie-bush-dog-park",
      "poi_latitude": "29.72655929999999",
      "poi_longitude": "-95.6686648",
      "poi_miles_from_property": "12.8 mi",
      "poi_walking_minutes": "4 hours 40 mins",
      "poi_biking_minutes": "1 hour 27 mins",
      "poi_driving_minutes": "23 mins",
      "poi_business_phone": "+1 281-353-8100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5652147039371264/019f1500-2d78-77db-b8d5-46fe84d8ec78.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1500-2d78-77db-b8d5-46fe84d8ec78",
        "storage_key": "property/5652147039371264/019f1500-2d78-77db-b8d5-46fe84d8ec78.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ8fQ455jeQIYRkyebEkDWMcU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "dog_park"
    },
    {
      "id": "ec_726028bc5a06d58f77c300a8",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5652147039371264",
      "source": "generator",
      "poi_name": "Heritage Park of Katy",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "6001 George Bush Dr, Katy, TX 77493, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5652147039371264/019f1501-e3fe-74f9-ac1f-3d5392b92f22.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1501-e3fe-74f9-ac1f-3d5392b92f22",
        "storage_key": "property/5652147039371264/019f1501-e3fe-74f9-ac1f-3d5392b92f22.webp",
        "width": 480,
        "height": 270
      },
      "poi_business_url": "http://hpkaty.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5023302876349893441&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "heritage-park-of-katy",
      "poi_latitude": "29.79022569999999",
      "poi_longitude": "-95.8270063",
      "poi_miles_from_property": "4.1 mi",
      "poi_walking_minutes": "1 hour 32 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 281-395-1124",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5652147039371264/019f1500-2d79-729c-8bca-b8c9604f9307.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1500-2d79-729c-8bca-b8c9604f9307",
        "storage_key": "property/5652147039371264/019f1500-2d79-729c-8bca-b8c9604f9307.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ0wTtWjAkQYYRQYsI-FlbtkU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "health"
    },
    {
      "id": "ec_09366f5a6e6e2489f0912f01",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5652147039371264",
      "source": "generator",
      "poi_name": "Kingsland Park & Ride",
      "poi_type": "Transportation & Transit",
      "poi_address": "21669 Kingsland Blvd, Katy, TX 77450, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5652147039371264/019f1501-e79a-759e-ae9b-68360048eabe.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1501-e79a-759e-ae9b-68360048eabe",
        "storage_key": "property/5652147039371264/019f1501-e79a-759e-ae9b-68360048eabe.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.ridemetro.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16228968268042078283&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kingsland-park--ride",
      "poi_latitude": "29.7747945",
      "poi_longitude": "-95.7449571",
      "poi_miles_from_property": "8.8 mi",
      "poi_walking_minutes": "3 hours 13 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 713-635-4000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5652147039371264/019f1501-ff80-741c-864b-d0f549804d53.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1501-ff80-741c-864b-d0f549804d53",
        "storage_key": "property/5652147039371264/019f1501-ff80-741c-864b-d0f549804d53.webp",
        "width": 138,
        "height": 192
      },
      "poi_google_place_id": "ChIJfz3tbkQnQYYRSwi8r6fgOOE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park_and_ride"
    },
    {
      "id": "ec_03f3e1bacfa7cd874a2c65c2",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5652147039371264",
      "source": "generator",
      "poi_name": "Grand Parkway Park & Ride",
      "poi_type": "Transportation & Transit",
      "poi_address": "1030 N Grand Pkwy, Katy, TX 77449, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5652147039371264/019f1501-ee1e-7543-8012-bedbed3a3b76.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1501-ee1e-7543-8012-bedbed3a3b76",
        "storage_key": "property/5652147039371264/019f1501-ee1e-7543-8012-bedbed3a3b76.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.ridemetro.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4263015384683988709&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "grand-parkway-park--ride",
      "poi_latitude": "29.7876219",
      "poi_longitude": "-95.7760204",
      "poi_miles_from_property": "7.0 mi",
      "poi_walking_minutes": "2 hours 34 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 713-635-4000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5652147039371264/019f1501-ff80-741c-864b-d0f549804d53.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1501-ff80-741c-864b-d0f549804d53",
        "storage_key": "property/5652147039371264/019f1501-ff80-741c-864b-d0f549804d53.webp",
        "width": 138,
        "height": 192
      },
      "poi_google_place_id": "ChIJ5-7oUuImQYYR5UYd7OdFKTs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park_and_ride"
    },
    {
      "id": "ec_7db38ffa739ec7218be7c154",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5652147039371264",
      "source": "generator",
      "poi_name": "Addicks Park & Ride",
      "poi_type": "Transportation & Transit",
      "poi_address": "14230 Old Katy Rd, Houston, TX 77079, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5652147039371264/019f1501-eef5-7134-90d6-696f11c1e2df.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1501-eef5-7134-90d6-696f11c1e2df",
        "storage_key": "property/5652147039371264/019f1501-eef5-7134-90d6-696f11c1e2df.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.ridemetro.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6059542481948761620&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "addicks-park--ride",
      "poi_latitude": "29.7872884",
      "poi_longitude": "-95.6383329",
      "poi_miles_from_property": "14.7 mi",
      "poi_walking_minutes": "5 hours 25 mins",
      "poi_biking_minutes": "1 hour 17 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 713-635-4000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5652147039371264/019f1501-ff80-741c-864b-d0f549804d53.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1501-ff80-741c-864b-d0f549804d53",
        "storage_key": "property/5652147039371264/019f1501-ff80-741c-864b-d0f549804d53.webp",
        "width": 138,
        "height": 192
      },
      "poi_google_place_id": "ChIJ1xDFp93bQIYRFN7xUcjRF1Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park_and_ride"
    },
    {
      "id": "ec_2a6c57546d01171fe024a474",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5652147039371264",
      "source": "generator",
      "poi_name": "Northwest Transit Center",
      "poi_type": "Transportation & Transit",
      "poi_address": "7373 Old Katy Rd, Houston, TX 77024, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5652147039371264/019f1501-e90d-720b-9af7-98f60ae37459.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1501-e90d-720b-9af7-98f60ae37459",
        "storage_key": "property/5652147039371264/019f1501-e90d-720b-9af7-98f60ae37459.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.ridemetro.org/pages/TC-Northwest.aspx",
      "poi_directions_map_url": "https://maps.google.com/?cid=4887889931563584101&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "northwest-transit-center",
      "poi_latitude": "29.7833768",
      "poi_longitude": "-95.4545941",
      "poi_miles_from_property": "25.7 mi",
      "poi_walking_minutes": "9 hours 29 mins",
      "poi_biking_minutes": "2 hours 38 mins",
      "poi_driving_minutes": "27 mins",
      "poi_business_phone": "+1 713-635-4000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5652147039371264/019f1500-2d79-729c-8bca-b8c9604f9307.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1500-2d79-729c-8bca-b8c9604f9307",
        "storage_key": "property/5652147039371264/019f1500-2d79-729c-8bca-b8c9604f9307.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJq3DSrsfGQIYRZUoO4P5F1UM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bus_stop"
    },
    {
      "id": "ec_43d122a9ed434394aa21168f",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5652147039371264",
      "source": "generator",
      "poi_name": "Northwest Station Park & Ride",
      "poi_type": "Transportation & Transit",
      "poi_address": "18502 Northwest Fwy, Houston, TX 77065, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5652147039371264/019f1501-ef65-756f-84f0-532f90f959a3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1501-ef65-756f-84f0-532f90f959a3",
        "storage_key": "property/5652147039371264/019f1501-ef65-756f-84f0-532f90f959a3.webp",
        "width": 1280,
        "height": 622
      },
      "poi_business_url": "https://www.ridemetro.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15540130698840525853&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "northwest-station-park--ride",
      "poi_latitude": "29.90224199999999",
      "poi_longitude": "-95.5940473",
      "poi_miles_from_property": "24.0 mi",
      "poi_walking_minutes": "8 hours 51 mins",
      "poi_biking_minutes": "2 hours 16 mins",
      "poi_driving_minutes": "31 mins",
      "poi_business_phone": "+1 713-635-4000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5652147039371264/019f1501-ff80-741c-864b-d0f549804d53.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1501-ff80-741c-864b-d0f549804d53",
        "storage_key": "property/5652147039371264/019f1501-ff80-741c-864b-d0f549804d53.webp",
        "width": 138,
        "height": 192
      },
      "poi_google_place_id": "ChIJ4yxMh1LQQIYRHUyIE4miqdc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park_and_ride"
    },
    {
      "id": "ec_6600b05d31e98efe7fc7611d",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5652147039371264",
      "source": "generator",
      "poi_name": "Cypress Park & Ride",
      "poi_type": "Transportation & Transit",
      "poi_address": "25210 US-290 Frontage Rd., Cypress, TX 77429, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5652147039371264/019f1501-f274-72ea-bdee-53be1f0cdd17.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1501-f274-72ea-bdee-53be1f0cdd17",
        "storage_key": "property/5652147039371264/019f1501-f274-72ea-bdee-53be1f0cdd17.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.ridemetro.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8813123989977222512&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cypress-park--ride",
      "poi_latitude": "29.9641577",
      "poi_longitude": "-95.6855147",
      "poi_miles_from_property": "27.3 mi",
      "poi_walking_minutes": "10 hours 1 min",
      "poi_biking_minutes": "1 hour 52 mins",
      "poi_driving_minutes": "30 mins",
      "poi_business_phone": "+1 713-635-4000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5652147039371264/019f1501-ff80-741c-864b-d0f549804d53.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1501-ff80-741c-864b-d0f549804d53",
        "storage_key": "property/5652147039371264/019f1501-ff80-741c-864b-d0f549804d53.webp",
        "width": 138,
        "height": 192
      },
      "poi_google_place_id": "ChIJ39ayTa3RQIYRcM0QMJOBTno",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park_and_ride"
    },
    {
      "id": "ec_af1798e4edbc0f4f2d714f5f",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5652147039371264",
      "source": "generator",
      "poi_name": "George Bush Intercontinental Airport",
      "poi_type": "Transportation & Transit",
      "poi_address": "2800 N Terminal Rd, Houston, TX 77032, USA",
      "poi_short_description": "Houston airport with an interterminal train & an outdoor sculpture depicting large, abstract flags.",
      "poi_long_description": "Houston airport with an interterminal train & an outdoor sculpture depicting large, abstract flags.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5652147039371264/019f1501-f2ed-756d-a605-bbd0611159e1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1501-f2ed-756d-a605-bbd0611159e1",
        "storage_key": "property/5652147039371264/019f1501-f2ed-756d-a605-bbd0611159e1.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.fly2houston.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11296915713098302001&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "george-bush-intercontinental-airport",
      "poi_latitude": "29.9931058",
      "poi_longitude": "-95.3416255",
      "poi_miles_from_property": "48.6 mi",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "4 hours 12 mins",
      "poi_driving_minutes": "50 mins",
      "poi_business_phone": "+1 281-230-3100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5652147039371264/019f1500-2d6e-71d9-b319-dbb0a320f341.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1500-2d6e-71d9-b319-dbb0a320f341",
        "storage_key": "property/5652147039371264/019f1500-2d6e-71d9-b319-dbb0a320f341.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJx1VD2SO0QIYRMcLAyPy0xpw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "international_airport"
    },
    {
      "id": "ec_9ca5a3739443201dce8c0628",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5652147039371264",
      "source": "generator",
      "poi_name": "Memorial Hermann Katy Hospital",
      "poi_type": "Major Employers & Offices",
      "poi_address": "23900 Katy Fwy, Katy, TX 77494, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5652147039371264/019f1500-08b1-75f8-9673-d388d3ab77af.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1500-08b1-75f8-9673-d388d3ab77af",
        "storage_key": "property/5652147039371264/019f1500-08b1-75f8-9673-d388d3ab77af.webp",
        "width": 800,
        "height": 450
      },
      "poi_business_url": "https://memorialhermann.org/locations/katy?utm_campaign=reputation-management&utm_segment=gmb_location-listing&utm_source=yext&utm_medium=organic-search",
      "poi_directions_map_url": "https://maps.google.com/?cid=75134535897600095&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "memorial-hermann-katy-hospital",
      "poi_latitude": "29.7875539",
      "poi_longitude": "-95.7864102",
      "poi_miles_from_property": "5.8 mi",
      "poi_walking_minutes": "2 hours 9 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 281-644-7000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5652147039371264/019f1500-2d22-7457-b0bb-acf9127de84e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1500-2d22-7457-b0bb-acf9127de84e",
        "storage_key": "property/5652147039371264/019f1500-2d22-7457-b0bb-acf9127de84e.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJq6qqqrogQYYRX1CKWnbuCgE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "general_hospital"
    },
    {
      "id": "ec_078bea2d6201545b3e770af6",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5652147039371264",
      "source": "generator",
      "poi_name": "Houston Methodist West Hospital",
      "poi_type": "Major Employers & Offices",
      "poi_address": "18500 Katy Fwy, Houston, TX 77094, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5652147039371264/019f1501-eef8-714b-94e7-8a1fdaa9d322.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1501-eef8-714b-94e7-8a1fdaa9d322",
        "storage_key": "property/5652147039371264/019f1501-eef8-714b-94e7-8a1fdaa9d322.webp",
        "width": 1280,
        "height": 629
      },
      "poi_business_url": "https://www.houstonmethodist.org/locations/katy-west/?utm_source=gmb&utm_medium=organic&utm_campaign=all_location_gmb&utm_content=website-click",
      "poi_directions_map_url": "https://maps.google.com/?cid=9315019254502396471&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "houston-methodist-west-hospital",
      "poi_latitude": "29.7872016",
      "poi_longitude": "-95.6982542",
      "poi_miles_from_property": "11.2 mi",
      "poi_walking_minutes": "4 hours 6 mins",
      "poi_biking_minutes": "59 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 832-522-1000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5652147039371264/019f1500-2d22-7457-b0bb-acf9127de84e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1500-2d22-7457-b0bb-acf9127de84e",
        "storage_key": "property/5652147039371264/019f1500-2d22-7457-b0bb-acf9127de84e.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJqYUrEObYQIYRNxKKrKiYRYE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "general_hospital"
    },
    {
      "id": "ec_7305d0b1936d3914d98dee03",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5652147039371264",
      "source": "generator",
      "poi_name": "Texas Children's Hospital West Campus",
      "poi_type": "Major Employers & Offices",
      "poi_address": "18200 Katy Fwy, Houston, TX 77094, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5652147039371264/019f1501-f3b0-75de-a3ae-5a4ea730e3cc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1501-f3b0-75de-a3ae-5a4ea730e3cc",
        "storage_key": "property/5652147039371264/019f1501-f3b0-75de-a3ae-5a4ea730e3cc.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.texaschildrens.org/locations/texas-childrens-hospital/west-campus",
      "poi_directions_map_url": "https://maps.google.com/?cid=7901152811411417951&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "texas-childrens-hospital-west-campus",
      "poi_latitude": "29.78780029999999",
      "poi_longitude": "-95.6928635",
      "poi_miles_from_property": "11.6 mi",
      "poi_walking_minutes": "4 hours 16 mins",
      "poi_biking_minutes": "1 hour 4 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 832-227-1000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5652147039371264/019f1500-2d22-7457-b0bb-acf9127de84e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1500-2d22-7457-b0bb-acf9127de84e",
        "storage_key": "property/5652147039371264/019f1500-2d22-7457-b0bb-acf9127de84e.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJWxiVseHYQIYRX6tBsJ6Ipm0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "ec_abcc00278bd11c78ec84fb98",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5652147039371264",
      "source": "generator",
      "poi_name": "Katy Independent School Dst",
      "poi_type": "Major Employers & Offices",
      "poi_address": "20370 Franz Rd, Katy, TX 77449, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://www.katyisd.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1801241881879051754&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "katy-independent-school-dst",
      "poi_latitude": "29.8021699",
      "poi_longitude": "-95.7398243",
      "poi_miles_from_property": "9.3 mi",
      "poi_walking_minutes": "3 hours 27 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 281-675-7000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5652147039371264/019f1500-2d23-727e-9230-507918367794.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1500-2d23-727e-9230-507918367794",
        "storage_key": "property/5652147039371264/019f1500-2d23-727e-9230-507918367794.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJhbPKPXgnQYYR6v30u_JL_xg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "ec_e1567f4c58a05f747b1f5657",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5652147039371264",
      "source": "generator",
      "poi_name": "Academy Sports + Outdoors",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1800 N Mason Rd, Katy, TX 77449, USA",
      "poi_short_description": "Sporting goods chain selling athletic apparel & footwear, plus outdoor gear & fitness equipment.",
      "poi_long_description": "Sporting goods chain selling athletic apparel & footwear, plus outdoor gear & fitness equipment.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5652147039371264/019f1500-1f4f-749c-af83-5df0f489b6e6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1500-1f4f-749c-af83-5df0f489b6e6",
        "storage_key": "property/5652147039371264/019f1500-1f4f-749c-af83-5df0f489b6e6.webp",
        "width": 1165,
        "height": 791
      },
      "poi_business_url": "https://www.academy.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14346416571706071188&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "academy-sports--outdoors",
      "poi_latitude": "29.7987497",
      "poi_longitude": "-95.7512596",
      "poi_miles_from_property": "8.4 mi",
      "poi_walking_minutes": "3 hours 6 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 281-646-5200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5652147039371264/019f1500-2d79-729c-8bca-b8c9604f9307.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1500-2d79-729c-8bca-b8c9604f9307",
        "storage_key": "property/5652147039371264/019f1500-2d79-729c-8bca-b8c9604f9307.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJi0DblXQnQYYRlFhRhNy1GMc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "ec_04ffd92071065d43ff99c704",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5652147039371264",
      "source": "generator",
      "poi_name": "Amazon HOU5 / HOU9",
      "poi_type": "Major Employers & Offices",
      "poi_address": "22525 Clay Rd, Katy, TX 77449, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5652147039371264/019f1501-f615-7444-84d6-d60d15a06239.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1501-f615-7444-84d6-d60d15a06239",
        "storage_key": "property/5652147039371264/019f1501-f615-7444-84d6-d60d15a06239.webp",
        "width": 1280,
        "height": 1280
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=12082720723472988830&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "amazon-hou5--hou9",
      "poi_latitude": "29.8301992",
      "poi_longitude": "-95.765365",
      "poi_miles_from_property": "9.7 mi",
      "poi_walking_minutes": "3 hours 34 mins",
      "poi_biking_minutes": "43 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5652147039371264/019f1500-2d79-729c-8bca-b8c9604f9307.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1500-2d79-729c-8bca-b8c9604f9307",
        "storage_key": "property/5652147039371264/019f1500-2d79-729c-8bca-b8c9604f9307.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJEbTJ40AnQYYRnrrbIntyrqc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "storage"
    },
    {
      "id": "ec_bd11759cfe3b92562ce89783",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5652147039371264",
      "source": "generator",
      "poi_name": "Katy Mills",
      "poi_type": "Major Employers & Offices",
      "poi_address": "5000 Katy Mills Cir, Katy, TX 77494, USA",
      "poi_short_description": "Complex with outlet stores for designer clothes, footwear & accessories, plus eateries & movies.",
      "poi_long_description": "Complex with outlet stores for designer clothes, footwear & accessories, plus eateries & movies.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5652147039371264/019f14ff-daa3-7478-bdbb-23e917592a4d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ff-daa3-7478-bdbb-23e917592a4d",
        "storage_key": "property/5652147039371264/019f14ff-daa3-7478-bdbb-23e917592a4d.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.simon.com/mall/katy-mills",
      "poi_directions_map_url": "https://maps.google.com/?cid=3336739692914759633&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "katy-mills",
      "poi_latitude": "29.7756348",
      "poi_longitude": "-95.8091819",
      "poi_miles_from_property": "5.2 mi",
      "poi_walking_minutes": "1 hour 55 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 281-644-5000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5652147039371264/019f1500-2d22-7457-b0bb-a8ecc36cd5e6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1500-2d22-7457-b0bb-a8ecc36cd5e6",
        "storage_key": "property/5652147039371264/019f1500-2d22-7457-b0bb-a8ecc36cd5e6.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ17sFi6EmQYYR0VchaBJ7Ti4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "ec_fdae35a88a4f82f4617b445b",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5652147039371264",
      "source": "generator",
      "poi_name": "LaCenterra at Cinco Ranch",
      "poi_type": "Major Employers & Offices",
      "poi_address": "23501 Cinco Ranch Blvd, Katy, TX 77494, USA",
      "poi_short_description": "Outdoor shopping center with business offices, clothing, footwear, beauty & gift shops, plus dining.",
      "poi_long_description": "Outdoor shopping center with business offices, clothing, footwear, beauty & gift shops, plus dining.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5652147039371264/019f14ff-cdae-70ac-8787-b41bd5b49eb1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ff-cdae-70ac-8787-b41bd5b49eb1",
        "storage_key": "property/5652147039371264/019f14ff-cdae-70ac-8787-b41bd5b49eb1.webp",
        "width": 750,
        "height": 421
      },
      "poi_business_url": "https://lacenterra.com/?utm_source=gmb&utm_medium=Yext",
      "poi_directions_map_url": "https://maps.google.com/?cid=17500870136583917237&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lacenterra-at-cinco-ranch",
      "poi_latitude": "29.7429973",
      "poi_longitude": "-95.7750596",
      "poi_miles_from_property": "5.8 mi",
      "poi_walking_minutes": "2 hours 8 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 281-395-5533",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5652147039371264/019f1500-2d22-7457-b0bb-a8ecc36cd5e6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1500-2d22-7457-b0bb-a8ecc36cd5e6",
        "storage_key": "property/5652147039371264/019f1500-2d22-7457-b0bb-a8ecc36cd5e6.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ-W5CySchQYYRtY5TZ6qU3_I",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "ec_64912757446a938bb7c8cfa3",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5652147039371264",
      "source": "generator",
      "poi_name": "Katy City Hall",
      "poi_type": "Major Employers & Offices",
      "poi_address": "901 Avenue C, Katy, TX 77493, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5652147039371264/019f1500-25e2-76e9-a56c-a203ebb2083a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1500-25e2-76e9-a56c-a203ebb2083a",
        "storage_key": "property/5652147039371264/019f1500-25e2-76e9-a56c-a203ebb2083a.webp",
        "width": 1280,
        "height": 718
      },
      "poi_business_url": "https://www.cityofkaty.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12571898859814934495&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "katy-city-hall",
      "poi_latitude": "29.7875543",
      "poi_longitude": "-95.8236655",
      "poi_miles_from_property": "3.7 mi",
      "poi_walking_minutes": "1 hour 23 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 281-391-4800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5652147039371264/019f1500-2d70-75cf-8dc8-af996ff541c9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1500-2d70-75cf-8dc8-af996ff541c9",
        "storage_key": "property/5652147039371264/019f1500-2d70-75cf-8dc8-af996ff541c9.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJPUhRZCUkQYYR31doe2dbeK4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_hall"
    },
    {
      "id": "ec_405c1bf389a0323d393ba333",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5652147039371264",
      "source": "generator",
      "poi_name": "Houston City College - Katy Campus",
      "poi_type": "Major Employers & Offices",
      "poi_address": "22910 Colonial Pkwy, Katy, TX 77449, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5652147039371264/019f14ff-e146-7327-a546-6c085c3a359d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ff-e146-7327-a546-6c085c3a359d",
        "storage_key": "property/5652147039371264/019f14ff-e146-7327-a546-6c085c3a359d.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.hccs.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13237354447510935994&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "houston-city-college---katy-campus",
      "poi_latitude": "29.7945044",
      "poi_longitude": "-95.768164",
      "poi_miles_from_property": "7.2 mi",
      "poi_walking_minutes": "2 hours 40 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 713-718-5757",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5652147039371264/019f1500-2d23-727e-9230-507918367794.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1500-2d23-727e-9230-507918367794",
        "storage_key": "property/5652147039371264/019f1500-2d23-727e-9230-507918367794.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJOzBdKpLYQIYRupnTSbyHtLc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    }
  ],
  "office_hours": [
    {
      "id": "custom_efe7be49-3c63-455d-bacb-bd89a60457d2",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5652147039371264",
      "day": "MON",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_1acf62de-da96-4891-af75-7bee224506e8",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5652147039371264",
      "day": "TUE",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_bbe4ee0e-53b2-4cff-9bd9-9d0215c77393",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5652147039371264",
      "day": "WED",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_123d0643-7e5a-4bb1-b9c8-bb17f87f4d9a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5652147039371264",
      "day": "FRI",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_47ee7725-0060-4933-b988-761c617d42c0",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5652147039371264",
      "day": "SAT",
      "open_time": "10:00",
      "close_time": "17:00"
    },
    {
      "id": "custom_33274172-ab62-44a0-8551-44a3180ac122",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5652147039371264",
      "day": "THU",
      "open_time": "09:00",
      "close_time": "19:00"
    }
  ],
  "reviews": [
    {
      "id": "custom_60e29f74-ea0c-4712-8a96-9f0c254f6486",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5652147039371264",
      "rating": "5.0",
      "name": "Teri Beck",
      "text": "I absolutely love the office team  Carolyn, Yennette, and Wendy are amazing! They’ve always worked with me and responded quickly whenever I needed something. I don’t understand the negative reviews because my experience has been great, especially being a second-chance renter. I haven’t had any issues at all. Everyone’s experience is different, but for me, the staff has been nothing but helpful and kind.",
      "date": "2025-10-08",
      "title": ""
    },
    {
      "id": "custom_96489c87-92fb-434d-b39b-f3684376a56e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5652147039371264",
      "rating": "4.0",
      "name": "Pam",
      "text": "It's basically a good and inexpensive place to live. The staff and maintenance are awesome.  The only problem is they need wheelchair ramps and some tenents have a bunch of stuff on their patios other than patio furniture. Also there are car repairs that could be necessary but some are extensive and makes some areas look bad. Also pool area could use and uplift",
      "date": "2025-06-02",
      "title": ""
    },
    {
      "id": "custom_9438ddc4-e973-4d12-b8a1-0430d8c4899d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5652147039371264",
      "rating": "5.0",
      "name": "Myranda McGee",
      "text": "I moved in yesterday and had a few things that needed to be fixed and ready before we could fully move in and they got it down within 30 mins. Today is a Saturday and I needed maintenance to fix something and even though they don't usually work on Saturdays they came and got the job done within a few hours. The apartments are nice, office staff has so far gone above and beyond trying to make sure we are happy and the apartment is ready. I have never seen or even heard of service like this. No apartment is \"perfect\" but they are giving perfect service! Hands down I can't wait to live here and see where things go.",
      "date": "2025-06-07",
      "title": ""
    },
    {
      "id": "custom_1e50e758-3ede-450a-8c1c-2360e2d77b2b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5652147039371264",
      "rating": "5.0",
      "name": "Dasia Hilder",
      "text": "My experience at Lodge at 1550 was hands down one of the best apartment tours I’ve ever had. The staff was warm and welcoming, but Yannette truly made the experience stand out. She was patient, informative, and genuinely invested in making sure I had all the details I needed—not just about the apartment, but about what would make it feel like home. What really stood out to me was how she went above and beyond, even as her shift was ending, to make sure every question was answered and I felt confident about my options. You can tell she genuinely cares, and that kind of energy makes all the difference. The community itself felt peaceful, and overall, I left with a really positive impression.  For anyone searching for a new home, I’d highly recommend stopping by for a tour—you’ll be in great hands ❤️",
      "date": "2025-03-08",
      "title": ""
    }
  ],
  "virtual_tours": [
    {
      "id": "ec_0b3a494115937f73682460e4",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5652147039371264",
      "source": "generator",
      "url_health_error": "false",
      "virtual_tour_description": "YouTube channel: American Landmark",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5652147039371264/019f14c3-cb0b-7098-9286-348a55ff8ed6.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019f14c3-cb0b-7098-9286-348a55ff8ed6",
        "storage_key": "property/5652147039371264/019f14c3-cb0b-7098-9286-348a55ff8ed6.webp",
        "width": 480,
        "height": 360
      },
      "virtual_tour_title": "Lodge at 1550",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://www.youtube.com/embed/PQPPh3Ov4_A"
    }
  ],
  "faqs": [],
  "fees": [],
  "pet_policies": [],
  "lead_collectors": [
    {
      "lead_collector_id": "0198aa45-bcef-77ed-a8aa-5befa5a5eea2",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "lodge-@-1550",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5652147039371264"
    },
    {
      "lead_collector_id": "0198aa45-bd51-7028-b59f-f1e0011b1913",
      "lead_source": "FACEBOOK_ADS",
      "name": "lodge-@-1550",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5652147039371264"
    },
    {
      "lead_collector_id": "0198aa45-bdb4-703d-a000-5d7b7f34f342",
      "lead_source": "LANDING_PAGE",
      "name": "lodge-@-1550",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5652147039371264"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5652147039371264",
      "source": "custom",
      "page_item_url": "dog-friendly-apartments-cinco-ranch-537",
      "search_query": "dog friendly apartments in Cinco Ranch",
      "category": "Amenity",
      "h1_title": "Dog Friendly Apartments in Cinco Ranch",
      "h2_subtitle": "Lodge @ 1550 features fantastic dog friendly apartments in Cinco Ranch. Spacious floor plans and a dog park make it perfect for pet lovers.",
      "page_copy": "Discover a pet paradise at Lodge @ 1550, offering dog friendly apartments in Cinco Ranch, TX. Our community boasts fantastic amenities tailored for both you and your four-legged friends. With a dedicated on-site dog park, your furry companion will enjoy their new home just as much as you do. Conveniently situated in the vibrant heart of Katy, our spacious one and two-bedroom floor plans provide stylish interiors, featuring modern kitchens and built-in bookcases.\n\nEnjoy the perfect blend of comfort and convenience with our pet-friendly policy. After a day at the park, unwind by the sparkling pool or socialize with neighbors at the resident clubhouse. Additional conveniences include a dishwasher, washer/dryer hookup, and a relaxing patio area. Lodge @ 1550 is the ideal choice for those seeking dog friendly apartments in Cinco Ranch.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5652147039371264/019f6c0f-a66b-70e9-99cb-2f808dcb8425.webp",
      "featured_image_media": {
        "alt_text": "Modern white kitchen with stainless steel appliances and ample counter space.",
        "public_id": "019f6c0f-a66b-70e9-99cb-2f808dcb8425",
        "storage_key": "property/5652147039371264/019f6c0f-a66b-70e9-99cb-2f808dcb8425.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Dog Friendly Apartments in Cinco Ranch, TX",
      "seo_description": "Discover Lodge @ 1550's dog friendly apartments in Cinco Ranch, offering a dog park and spacious floor plans tailored for pet lovers.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5652147039371264",
      "source": "custom",
      "page_item_url": "luxury-apartments-pools-fort-bend-county-35",
      "search_query": "luxury apartments with pools Fort Bend County",
      "category": "Amenity",
      "h1_title": "Luxury Apartments with Pools in Fort Bend",
      "h2_subtitle": "Explore Lodge @ 1550, offering luxury apartments with pools in Fort Bend County and enjoy top-notch amenities.",
      "page_copy": "Experience upscale living at Lodge @ 1550, where luxury meets leisure with our apartments featuring stunning pools in Fort Bend County. Nestled in the lush enclave of Cinco Ranch, our community offers the perfect balance of style and comfort. Dive into relaxation with our luxurious pool, an ideal spot to unwind and soak up the Texas sun.\n\nOur one and two-bedroom floor plans provide not only upscale amenities like built-in bookcases and modern kitchens but also unparalleled services such as a dedicated resident clubhouse. Situated in the heart of Katy, TX, Lodge @ 1550 is the epitome of luxury living. Dive into a life of comfort and convenience in Fort Bend County's premier luxury apartments.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5652147039371264/019f6c0f-a66b-70e9-99cb-2f808dcb8425.webp",
      "featured_image_media": {
        "alt_text": "Modern white kitchen with stainless steel appliances and ample counter space.",
        "public_id": "019f6c0f-a66b-70e9-99cb-2f808dcb8425",
        "storage_key": "property/5652147039371264/019f6c0f-a66b-70e9-99cb-2f808dcb8425.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Luxury Apartments with Pools in Fort Bend",
      "seo_description": "Discover luxury apartments with pools in Fort Bend County at Lodge @ 1550, featuring upscale amenities and a prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5652147039371264",
      "source": "custom",
      "page_item_url": "apartment-fitness-center-katy-tx-607",
      "search_query": "apartment fitness center Katy TX",
      "category": "Amenity",
      "h1_title": "Apartment Fitness Center in Katy, TX",
      "h2_subtitle": "Lodge @ 1550 offers an apartment fitness center in Katy, TX. Enjoy a healthy lifestyle with modern amenities at our community.",
      "page_copy": "Embrace an active lifestyle at Lodge @ 1550, featuring a modern apartment fitness center in Katy, TX. Located in the desirable Cinco Ranch area, our community provides residents with the convenience of a well-equipped fitness center right at their doorstep. Whether you prefer cardio workouts or strength training, our facilities cater to all fitness levels.\n\nBeyond the fitness center, enjoy the suburban charm with top-notch amenities such as a refreshing swimming pool and a spacious clubhouse. Choose from our beautifully designed one and two-bedroom floor plans, each fitted with stylish interiors including modern kitchens, built-in bookcases, and patios. Lodge @ 1550 is the perfect place to call home for those seeking both leisure and fitness in Katy, TX.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5652147039371264/019f6c0f-a66b-70e9-99cb-2f808dcb8425.webp",
      "featured_image_media": {
        "alt_text": "Modern white kitchen with stainless steel appliances and ample counter space.",
        "public_id": "019f6c0f-a66b-70e9-99cb-2f808dcb8425",
        "storage_key": "property/5652147039371264/019f6c0f-a66b-70e9-99cb-2f808dcb8425.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartment Fitness Center in Katy, TX",
      "seo_description": "Stay fit at Lodge @ 1550's apartment fitness center in Katy, TX, offering modern amenities and spacious floor plans in Cinco Ranch.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5652147039371264",
      "source": "custom",
      "page_item_url": "apartments-walk-in-closets-77494-698",
      "search_query": "apartments with walk-in closets 77494",
      "category": "Amenity",
      "h1_title": "Apartments with Walk-in Closets in 77494",
      "h2_subtitle": "Explore Lodge @ 1550 for apartments with spacious walk-in closets in 77494. Enjoy stylish living and ample storage space in Katy, TX.",
      "page_copy": "Discover the ultimate in spacious living at Lodge @ 1550, offering apartments with walk-in closets in the 77494 area. Nestled in the desirable Cinco Ranch neighborhood of Katy, TX, our community provides expansive floor plans that cater to both your storage needs and lifestyle aspirations. With abundant closet space, you'll have plenty of room to organize your belongings comfortably.\n\nLodge @ 1550 features modern amenities that enhance your living experience, including a sparkling pool, a dog park, and a resident clubhouse. Enjoy stylish interiors equipped with modern kitchens and patios that offer serene views. Perfectly balancing practicality and luxury, our one and two-bedroom apartments are ideal for those seeking walk-in closets and a vibrant community in Katy, TX.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5652147039371264/019f6c0f-a66b-70e9-99cb-2f808dcb8425.webp",
      "featured_image_media": {
        "alt_text": "Modern white kitchen with stainless steel appliances and ample counter space.",
        "public_id": "019f6c0f-a66b-70e9-99cb-2f808dcb8425",
        "storage_key": "property/5652147039371264/019f6c0f-a66b-70e9-99cb-2f808dcb8425.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with Walk-in Closets in 77494",
      "seo_description": "Find spacious apartments with walk-in closets in 77494 at Lodge @ 1550, offering modern amenities and stylish interiors in Katy, TX.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5652147039371264",
      "source": "custom",
      "page_item_url": "in-unit-laundry-apartments-near-katy-771",
      "search_query": "in-unit laundry apartments near Katy",
      "category": "Amenity",
      "h1_title": "In-Unit Laundry Apartments Near Katy",
      "h2_subtitle": "Find in-unit laundry apartments near Katy at Lodge @ 1550, offering convenient living with modern amenities in a prime location.",
      "page_copy": "Enjoy the ultimate convenience of in-unit laundry at Lodge @ 1550, located near the heart of Katy, TX. Our apartments are designed to simplify your lifestyle by featuring washer/dryer hookups, allowing you to do laundry in the comfort of your own home. Situated in the vibrant Cinco Ranch area, Lodge @ 1550 combines convenience with style.\n\nOur community offers an array of attractive amenities, including a refreshing swimming pool, a dog park, and a spacious resident clubhouse. Choose from thoughtfully designed one and two-bedroom floor plans that feature modern kitchens and chic interiors. Located near Katy, TX, Lodge @ 1550 provides the perfect balance of luxury and practicality, making it an ideal choice for those seeking in-unit laundry and exceptional living.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5652147039371264/019f6c0f-a66b-70e9-99cb-2f808dcb8425.webp",
      "featured_image_media": {
        "alt_text": "Modern white kitchen with stainless steel appliances and ample counter space.",
        "public_id": "019f6c0f-a66b-70e9-99cb-2f808dcb8425",
        "storage_key": "property/5652147039371264/019f6c0f-a66b-70e9-99cb-2f808dcb8425.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "In-Unit Laundry Apartments Near Katy",
      "seo_description": "Lodge @ 1550 offers in-unit laundry apartments near Katy, TX, combining modern amenities with a convenient location in the Cinco Ranch area.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5652147039371264",
      "source": "custom",
      "page_item_url": "1-bedroom-apartments-katy-tx-792",
      "search_query": "1 bedroom apartments katy tx",
      "category": "Floorplan",
      "h1_title": "1 Bedroom Apartments in Katy, TX",
      "h2_subtitle": "Discover stylish 1 bedroom apartments in Katy, TX at Lodge @ 1550. Enjoy modern amenities and spacious living in a prime location.",
      "page_copy": "Find the perfect one-bedroom apartment in Katy, TX at Lodge @ 1550. Our community features well-designed floor plans that combine comfort and style, providing you with a cozy yet spacious living environment. Situated in the popular Cinco Ranch area, we're proud to offer residents a prime location along with numerous modern conveniences.\n\nResidents at Lodge @ 1550 enjoy access to a host of desirable amenities, including a serene pool, dog park, and vibrant resident clubhouse. Our one-bedroom homes feature functional layouts with stylish interiors like modern kitchens, built-in bookcases, and expansive patios. Whether you're downsizing or just starting out, Lodge @ 1550 provides a welcoming community in the heart of Katy, TX.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5652147039371264/019f6c0f-a66b-70e9-99cb-2f808dcb8425.webp",
      "featured_image_media": {
        "alt_text": "Modern white kitchen with stainless steel appliances and ample counter space.",
        "public_id": "019f6c0f-a66b-70e9-99cb-2f808dcb8425",
        "storage_key": "property/5652147039371264/019f6c0f-a66b-70e9-99cb-2f808dcb8425.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "1 Bedroom Apartments in Katy, TX",
      "seo_description": "Explore 1 bedroom apartments in Katy, TX at Lodge @ 1550. Enjoy modern living with top amenities in the sought-after Cinco Ranch area.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5652147039371264",
      "source": "custom",
      "page_item_url": "2-bedroom-apartments-cinco-ranch-652",
      "search_query": "2 bedroom apartments cinco ranch",
      "category": "Floorplan",
      "h1_title": "2 Bedroom Apartments in Cinco Ranch",
      "h2_subtitle": "Explore spacious 2 bedroom apartments in Cinco Ranch at Lodge @ 1550, offering modern amenities and stylish interiors in a prime location.",
      "page_copy": "Located in the desirable Cinco Ranch area, Lodge @ 1550 offers spacious two-bedroom apartments perfect for a dynamic lifestyle. Our thoughtfully designed floor plans provide ample space and comfort, making our community an ideal choice for those seeking stylish living in Katy, TX. Experience the convenience of living in a sought-after neighborhood with easy access to local amenities.\n\nLodge @ 1550 enhances your living experience through a variety of excellent amenities, including a sparkling pool, a dog park, and a vibrant resident clubhouse. Each two-bedroom apartment is outfitted with modern features such as contemporary kitchens, built-in bookcases, and private patios. Join our community and enjoy the perfect blend of comfort and convenience at Lodge @ 1550 in Cinco Ranch.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5652147039371264/019f6c0f-a66b-70e9-99cb-2f808dcb8425.webp",
      "featured_image_media": {
        "alt_text": "Modern white kitchen with stainless steel appliances and ample counter space.",
        "public_id": "019f6c0f-a66b-70e9-99cb-2f808dcb8425",
        "storage_key": "property/5652147039371264/019f6c0f-a66b-70e9-99cb-2f808dcb8425.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "2 Bedroom Apartments in Cinco Ranch",
      "seo_description": "Find spacious 2 bedroom apartments in Cinco Ranch at Lodge @ 1550. Enjoy modern amenities and a lively community in Katy, TX.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5652147039371264",
      "source": "custom",
      "page_item_url": "apartments-near-houston-community-college-katy-301",
      "search_query": "apartments near houston community college katy",
      "category": "School",
      "h1_title": "Apartments Near Houston Community College Katy",
      "h2_subtitle": "Discover convenient apartments near Houston Community College Katy at Lodge @ 1550, featuring modern living in a prime location.",
      "page_copy": "Lodge @ 1550 offers ideal living accommodations for students and faculty seeking apartments near Houston Community College in Katy, TX. Our community is nestled in the vibrant Cinco Ranch neighborhood, providing a convenient commute with access to local amenities and educational facilities. Whether you're a student or a professional, Lodge @ 1550 caters to varied lifestyles with well-designed floor plans.\n\nImmerse yourself in modern living with our range of amenities, including a refreshing swimming pool, a cozy resident clubhouse, and a dedicated dog park. Each apartment comes complete with stylish interiors, modern kitchens, and washer/dryer hookups. Enjoy a supportive community atmosphere while remaining close to Houston Community College Katy, enhancing both your academic and social experiences.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5652147039371264/019f6c0f-a66b-70e9-99cb-2f808dcb8425.webp",
      "featured_image_media": {
        "alt_text": "Modern white kitchen with stainless steel appliances and ample counter space.",
        "public_id": "019f6c0f-a66b-70e9-99cb-2f808dcb8425",
        "storage_key": "property/5652147039371264/019f6c0f-a66b-70e9-99cb-2f808dcb8425.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Houston Community College Katy",
      "seo_description": "Find modern apartments near Houston Community College Katy at Lodge @ 1550, offering a convenient location with luxurious amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5652147039371264",
      "source": "custom",
      "page_item_url": "lodge-at-1550-close-to-blinn-college-sealy-campus-47",
      "search_query": "lodge at 1550 close to blinn college sealy campus",
      "category": "School",
      "h1_title": "Lodge @ 1550 Near Blinn College Sealy Campus",
      "h2_subtitle": "Experience comfortable living at Lodge @ 1550 close to Blinn College Sealy Campus, offering modern amenities and spacious apartments.",
      "page_copy": "Lodge @ 1550 is a fantastic option for individuals seeking convenient accommodations near Blinn College Sealy Campus. Situated in the dynamic Cinco Ranch community of Katy, TX, our property offers easy access to educational facilities and local attractions, making it an ideal choice for both students and professionals. Enjoy being part of a vibrant community while also benefiting from a short commute.\n\nOur residents enjoy a variety of premium features, including a refreshing pool, a lively resident clubhouse, and a dedicated dog park, all designed to enhance your living experience. Each apartment at Lodge @ 1550 is outfitted with modern conveniences such as stylish kitchens, built-in bookcases, and private patios. Discover a supportive and energetic home base when you choose Lodge @ 1550 close to Blinn College Sealy Campus.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5652147039371264/019f6c0f-a66b-70e9-99cb-2f808dcb8425.webp",
      "featured_image_media": {
        "alt_text": "Modern white kitchen with stainless steel appliances and ample counter space.",
        "public_id": "019f6c0f-a66b-70e9-99cb-2f808dcb8425",
        "storage_key": "property/5652147039371264/019f6c0f-a66b-70e9-99cb-2f808dcb8425.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "<p class=\"rteBlock\">Apartments Near Blinn College Sealy Campus</p>",
      "seo_description": "Find ideal living at Lodge @ 1550 near Blinn College Sealy Campus, offering modern amenities in a convenient Katy, TX location.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5652147039371264",
      "source": "custom",
      "page_item_url": "apartments-near-houston-baptist-university-fort-bend-county-106",
      "search_query": "apartments near houston baptist university fort bend county",
      "category": "School",
      "h1_title": "Apartments Near Houston Baptist University",
      "h2_subtitle": "Explore modern apartments near Houston Baptist University in Fort Bend County at Lodge @ 1550, offering ideal accommodations and amenities.",
      "page_copy": "Discover the perfect home base at Lodge @ 1550, ideally situated for those seeking apartments near Houston Baptist University in Fort Bend County. Our community is located in the dynamic Cinco Ranch area of Katy, TX, offering a vibrant atmosphere with convenient access to educational institutions and local conveniences. Whether you're a student or faculty member, you'll find our location perfectly suited to your lifestyle needs.\n\nAt Lodge @ 1550, residents enjoy a wide range of amenities designed to complement their lifestyle. From a sparkling pool to a modern resident clubhouse and a dog park, every feature is crafted for comfort and convenience. Our spacious apartments boast contemporary kitchens, built-in bookcases, and relaxing patios, ensuring a homely environment close to Houston Baptist University.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5652147039371264/019f6c0f-a66b-70e9-99cb-2f808dcb8425.webp",
      "featured_image_media": {
        "alt_text": "Modern white kitchen with stainless steel appliances and ample counter space.",
        "public_id": "019f6c0f-a66b-70e9-99cb-2f808dcb8425",
        "storage_key": "property/5652147039371264/019f6c0f-a66b-70e9-99cb-2f808dcb8425.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Houston Baptist University",
      "seo_description": "Find ideal apartments near Houston Baptist University in Fort Bend County at Lodge @ 1550, offering modern amenities and convenient living.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5652147039371264",
      "source": "custom",
      "page_item_url": "lodge-at-1550-near-art-institute-of-houston-858",
      "search_query": "lodge @ 1550 near art institute of houston",
      "category": "School",
      "h1_title": "Lodge @ 1550 Near Art Institute of Houston",
      "h2_subtitle": "Discover Lodge @ 1550, perfectly positioned near Art Institute of Houston, offering a blend of comfort and convenience for students and professionals.",
      "page_copy": "Lodge @ 1550 offers an exceptional living experience for those wanting proximity to the Art Institute of Houston. Located in the vibrant Cinco Ranch community of Katy, TX, our residences provide easy access to a wealth of cultural and educational opportunities. With a straightforward commute to the Institute, students and staff alike will appreciate the blend of convenience and tranquility our property offers.\n\nOur community features a variety of amenities designed to enhance your lifestyle, including a refreshing pool, a bustling resident clubhouse, and a well-equipped dog park. Each apartment at Lodge @ 1550 boasts top-notch interiors, including modern kitchens, built-in bookcases, and private patios, creating a perfect home environment for focus and creativity, just a short distance from the Art Institute of Houston.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5652147039371264/019f6c0f-a66b-70e9-99cb-2f808dcb8425.webp",
      "featured_image_media": {
        "alt_text": "Modern white kitchen with stainless steel appliances and ample counter space.",
        "public_id": "019f6c0f-a66b-70e9-99cb-2f808dcb8425",
        "storage_key": "property/5652147039371264/019f6c0f-a66b-70e9-99cb-2f808dcb8425.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "<p class=\"rteBlock\">Apartments Near Art Institute of Houston</p>",
      "seo_description": "Live comfortably at Lodge @ 1550 near Art Institute of Houston. Enjoy modern amenities and convenient access to educational and cultural venues.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5652147039371264",
      "source": "custom",
      "page_item_url": "apartments-near-woodcreek-elementary-school-katy-tx-739",
      "search_query": "apartments near woodcreek elementary school katy tx",
      "category": "School",
      "h1_title": "Apartments Near Woodcreek Elementary School",
      "h2_subtitle": "Find spacious living at Lodge @ 1550, located near Woodcreek Elementary School in Katy, TX, offering family-friendly amenities and environments.",
      "page_copy": "If you're seeking apartments near Woodcreek Elementary School in Katy, TX, look no further than Lodge @ 1550. Our community is perfectly positioned in the bustling Cinco Ranch neighborhood, providing families with a convenient location that supports both education and vibrant living. This proximity makes our property an ideal choice for families looking to balance work, school, and leisure.\n\nLodge @ 1550 offers numerous amenities that cater to both adults and children. Enjoy a refreshing swim in our pool, meet neighbors at our resident clubhouse, or spend quality time with your pets at our dog park. Each apartment is designed with thoughtful features such as modern kitchens, built-in bookcases, and private patios. Experience a wholesome community atmosphere while benefiting from an excellent school district including Woodcreek Elementary.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5652147039371264/019f6c0f-a66b-70e9-99cb-2f808dcb8425.webp",
      "featured_image_media": {
        "alt_text": "Modern white kitchen with stainless steel appliances and ample counter space.",
        "public_id": "019f6c0f-a66b-70e9-99cb-2f808dcb8425",
        "storage_key": "property/5652147039371264/019f6c0f-a66b-70e9-99cb-2f808dcb8425.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Woodcreek Elementary School",
      "seo_description": "Discover family-friendly apartments near Woodcreek Elementary School at Lodge @ 1550 in Katy, TX. Enjoy modern amenities and a convenient location.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5652147039371264",
      "source": "custom",
      "page_item_url": "lodge-at-1550-near-woodcreek-j-high-cinco-ranch-346",
      "search_query": "lodge at 1550 near woodcreek j high school cinco ranch",
      "category": "School",
      "h1_title": "Lodge at 1550 Near Woodcreek J High",
      "h2_subtitle": "Explore Lodge at 1550, conveniently located near Woodcreek J High in Cinco Ranch, offering a family-friendly living environment.",
      "page_copy": "Lodge at 1550 offers an ideal residence for families looking to stay close to Woodcreek J High School in Cinco Ranch. Nestled in a vibrant community in Katy, TX, our property provides an easy commute, ensuring that school runs are convenient and quick. Parents and students appreciate the community-friendly atmosphere that Lodge at 1550 offers, fostering both educational development and leisure.\n\nOur community comes equipped with amenities aimed at enhancing family life. Whether unwinding by the refreshing pool, gathering in our resident clubhouse, or enjoying a day out in our dog park, there are plenty of ways to enjoy time together. Each apartment is crafted with care, featuring modern kitchens and private patios, ensuring a comfortable and welcoming home from which students can excel both academically and socially near Woodcreek J High.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5652147039371264/019f6c0f-a66b-70e9-99cb-2f808dcb8425.webp",
      "featured_image_media": {
        "alt_text": "Modern white kitchen with stainless steel appliances and ample counter space.",
        "public_id": "019f6c0f-a66b-70e9-99cb-2f808dcb8425",
        "storage_key": "property/5652147039371264/019f6c0f-a66b-70e9-99cb-2f808dcb8425.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "<p class=\"rteBlock\">Apartments Near Woodcreek J High</p>",
      "seo_description": "Lodge at 1550 offers the perfect home near Woodcreek J High School in Cinco Ranch, providing great amenities and a supportive community environment.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5652147039371264",
      "source": "custom",
      "page_item_url": "apartments-close-to-trinity-charter-school-fort-bend-511",
      "search_query": "apartments close to trinity charter school fort bend county",
      "category": "School",
      "h1_title": "Apartments Close to Trinity Charter School",
      "h2_subtitle": "Experience premier living at Lodge @ 1550, just a short drive from Trinity Charter School in Fort Bend County, offering modern comforts and convenience.",
      "page_copy": "For families seeking apartments close to Trinity Charter School in Fort Bend County, Lodge @ 1550 is the perfect choice. Situated in the vibrant area of Katy, TX, within the thriving Cinco Ranch community, our property offers easy access to the school, making mornings and afternoons stress-free for parents and students alike. This ideal location provides a harmonious blend of educational excellence and high-quality living.\n\nAt Lodge @ 1550, residents can enjoy a host of amenities designed for comfort and community interaction. Relax by the pool, host gatherings at our resident clubhouse, or take a stroll with your furry friend in our dog park. Our thoughtfully-designed apartments feature modern kitchens, spacious interiors, and cozy patios, ensuring a comfortable and homey atmosphere just a short distance from Trinity Charter School.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5652147039371264/019f6c0f-a66b-70e9-99cb-2f808dcb8425.webp",
      "featured_image_media": {
        "alt_text": "Modern white kitchen with stainless steel appliances and ample counter space.",
        "public_id": "019f6c0f-a66b-70e9-99cb-2f808dcb8425",
        "storage_key": "property/5652147039371264/019f6c0f-a66b-70e9-99cb-2f808dcb8425.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "<p class=\"rteBlock\">Apartments Near Trinity Charter School</p>",
      "seo_description": "Find your home at Lodge @ 1550, offering beautiful apartments close to Trinity Charter School in Fort Bend County with top amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5652147039371264",
      "source": "custom",
      "page_item_url": "lodge-1550-near-katy-high-school-tx-836",
      "search_query": "lodge @ 1550 near katy high school tx",
      "category": "School",
      "h1_title": "Lodge @ 1550 Near Katy High School",
      "h2_subtitle": "Discover the convenience of living at Lodge @ 1550, located near Katy High School, TX, offering top-tier amenities and a vibrant community.",
      "page_copy": "Find the perfect home at Lodge @ 1550, conveniently located near Katy High School in Texas. Situated in the lively Cinco Ranch neighborhood of Katy, TX, our community provides students and families easy access to education coupled with a vibrant residential atmosphere. This proximity ensures that students have a short commute, allowing more time for studies and extracurricular activities.\n\nResidents of Lodge @ 1550 enjoy a range of first-class amenities, including a refreshing pool, an inviting resident clubhouse, and a dedicated dog park. Our spacious apartments feature modern kitchens and private patios, creating a welcoming environment for study and relaxation. Experience the benefits of living near Katy High School, where academic excellence meets unparalleled residential comfort.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5652147039371264/019f6c0f-a66b-70e9-99cb-2f808dcb8425.webp",
      "featured_image_media": {
        "alt_text": "Modern white kitchen with stainless steel appliances and ample counter space.",
        "public_id": "019f6c0f-a66b-70e9-99cb-2f808dcb8425",
        "storage_key": "property/5652147039371264/019f6c0f-a66b-70e9-99cb-2f808dcb8425.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "<p class=\"rteBlock\">Apartments Near Katy High School</p>",
      "seo_description": "Live at Lodge @ 1550, a beautiful residence near Katy High School, TX. Enjoy exceptional amenities and community spirit.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5652147039371264",
      "source": "custom",
      "page_item_url": "apartments-near-first-classical-academy-katy-435",
      "search_query": "apartments near first classical academy katy",
      "category": "School",
      "h1_title": "Apartments Near First Classical Academy",
      "h2_subtitle": "Discover Lodge @ 1550 apartments, conveniently located near First Classical Academy in Katy. Enjoy a blend of luxury and educational proximity.",
      "page_copy": "Lodge @ 1550 offers an exceptional living experience with apartments near First Classical Academy in Katy. Located in the vibrant Cinco Ranch area, our community provides easy access to one of Katy's esteemed educational institutions, making daily commutes manageable and efficient for families prioritizing education and convenience.\n\nOur residents enjoy a host of superior amenities designed to enhance modern lifestyles. Whether taking a dip in our refreshing pool, socializing in our fully-equipped clubhouse, or enjoying the pet-friendly dog park, there's something for everyone. The spacious interiors feature modern kitchens and comfortable patios, perfect for unwinding after a busy day at the academy. Discover the perfect balance between superior apartment living and educational excellence at Lodge @ 1550.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5652147039371264/019f6c0f-a66b-70e9-99cb-2f808dcb8425.webp",
      "featured_image_media": {
        "alt_text": "Modern white kitchen with stainless steel appliances and ample counter space.",
        "public_id": "019f6c0f-a66b-70e9-99cb-2f808dcb8425",
        "storage_key": "property/5652147039371264/019f6c0f-a66b-70e9-99cb-2f808dcb8425.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near First Classical Academy Katy",
      "seo_description": "Lodge @ 1550 offers beautiful apartments near First Classical Academy in Katy, blending luxury amenities with educational accessibility.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5652147039371264",
      "source": "custom",
      "page_item_url": "lodge-at-1550-close-to-mirus-academy-510",
      "search_query": "lodge at 1550 close to mirus academy",
      "category": "School",
      "h1_title": "Lodge at 1550 Close to Mirus Academy",
      "h2_subtitle": "Live conveniently at Lodge at 1550, located close to Mirus Academy in Katy. Enjoy stylish living just minutes from education excellence.",
      "page_copy": "Discover the ideal blend of proximity and comfort at Lodge at 1550, located close to Mirus Academy in Katy. Our community in the thriving Cinco Ranch neighborhood provides families with an ideal location, ensuring daily commutes to the academy are both brief and stress-free. This convenience allows families to enjoy more quality time at home and focus on educational pursuits.\n\nLodge at 1550 offers a wide range of amenities that cater to a modern lifestyle. Residents can take advantage of our sparkling pool, socialize with neighbors in the community clubhouse, or enjoy leisurely walks with pets in the dedicated dog park. The stylish interiors feature modern kitchen designs and relaxing patios, providing a tranquil retreat after a busy day. Choose Lodge at 1550 for optimal living near Mirus Academy.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5652147039371264/019f6c0f-a66b-70e9-99cb-2f808dcb8425.webp",
      "featured_image_media": {
        "alt_text": "Modern white kitchen with stainless steel appliances and ample counter space.",
        "public_id": "019f6c0f-a66b-70e9-99cb-2f808dcb8425",
        "storage_key": "property/5652147039371264/019f6c0f-a66b-70e9-99cb-2f808dcb8425.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "<p class=\"rteBlock\">Apartments Near Mirus Academy</p>",
      "seo_description": "Find your new home at Lodge at 1550, close to Mirus Academy. Offering convenience and top-tier amenities in Katy.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5652147039371264",
      "source": "custom",
      "page_item_url": "apartments-near-katy-adventist-christian-school-77494-716",
      "search_query": "apartments near katy adventist christian school 77494",
      "category": "School",
      "h1_title": "Apartments Near Katy Adventist School",
      "h2_subtitle": "Find your home at Lodge @ 1550, offering apartments near Katy Adventist Christian School in the 77494 area, with unmatched convenience and amenities.",
      "page_copy": "Discover premier living at Lodge @ 1550, featuring apartments near Katy Adventist Christian School in the 77494 area. Located in the bustling Cinco Ranch neighborhood, our community offers families quick and convenient access to this respected educational institution, making it easier for children to focus on their studies while parents enjoy a seamless daily routine.\n\nLodge @ 1550 provides a delightful living environment with a variety of modern amenities designed to enhance comfort and lifestyle. Residents can relax in our enticing pool, gather with friends in the welcoming clubhouse, or enjoy time with their furry friends at the on-site dog park. Each apartment boasts contemporary kitchen spaces and serene patios, creating a perfect living space close to Katy Adventist Christian School.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5652147039371264/019f6c0f-a66b-70e9-99cb-2f808dcb8425.webp",
      "featured_image_media": {
        "alt_text": "Modern white kitchen with stainless steel appliances and ample counter space.",
        "public_id": "019f6c0f-a66b-70e9-99cb-2f808dcb8425",
        "storage_key": "property/5652147039371264/019f6c0f-a66b-70e9-99cb-2f808dcb8425.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Katy Adventist School 77494",
      "seo_description": "Explore Lodge @ 1550, with beautiful apartments near Katy Adventist Christian School in 77494. Enjoy convenience and modern amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_csm",
      "type": "STRING",
      "value": "jordanh@repli360.com"
    },
    {
      "ID": "custom_qb_id",
      "type": "STRING",
      "value": "2172"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "2376471525"
    },
    {
      "ID": "custom_leasing_ai",
      "type": "STRING",
      "value": "<script async src=\"https://cdn.leasing.ai/prod/v1/loader.js?pid=69db514f9eb73dfa48ba5a37\"></script>\n<img src=\"https://api.leasing.ai/v1/widgets/pixel/69db514f9eb73dfa48ba5a37\" width=\"1\" height=\"1\" style=\"display:none\" alt=\"\" />"
    },
    {
      "ID": "custom_realpage_id",
      "type": "STRING",
      "value": "4600726"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-NB7Q293"
    },
    {
      "ID": "custom_rollout_phase",
      "type": "STRING",
      "value": "2"
    },
    {
      "ID": "custom_ads_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_knock_company_id",
      "type": "STRING",
      "value": "3165"
    },
    {
      "ID": "custom_seo_subscription",
      "type": "STRING",
      "value": "essential"
    },
    {
      "ID": "custom_hubspot_company_id",
      "type": "STRING",
      "value": "8443838469"
    },
    {
      "ID": "custom_knock_community_id",
      "type": "STRING",
      "value": "e7e11f17c76e29ab"
    },
    {
      "ID": "custom_knock_company_token",
      "type": "STRING",
      "value": "1f195820242ac1100a1b122d7087a021"
    },
    {
      "ID": "custom_social_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_engrain_sightmap_url",
      "type": "STRING",
      "value": "https://sightmap.com/embed/l27vqqgqvox"
    },
    {
      "ID": "custom_self_guided_tour_url",
      "type": "STRING",
      "value": "https://selftournow.com/property/d3afd1b5-1548-4e73-b6a9-6d7676dc368b"
    },
    {
      "ID": "custom_website_subscription",
      "type": "STRING",
      "value": "custom"
    },
    {
      "ID": "custom_knock_tour_button_popup",
      "type": "STRING",
      "value": "<button onclick=\"event.preventDefault(); knockDoorway.openScheduling();\">Book tour</button>"
    },
    {
      "ID": "custom_ppc_tracking_phone_number",
      "type": "STRING",
      "value": "346-585-7294"
    },
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6IkJhNlJISzlCdTMwWldxaDhZVDJSM3c9PSIsInZhbHVlIjoiWGsray9ZVUZrSUs1V2pnMEYyZkV6dz09IiwibWFjIjoiMzE5MDU3MTVkZGNhYjE5NTFmYzEyOGNlZmVlOTY2MzQ5NzViYTgxZTE2NTE3NmQ1YTdkNTgwMTYyZTY2ZGMyNyJ9"
    },
    {
      "ID": "custom_household_income_qualification_multiplier",
      "type": "FLOAT",
      "value": "3"
    }
  ],
  "custom_csm": "jordanh@repli360.com",
  "custom_qb_id": "2172",
  "custom_repli_id": "2376471525",
  "custom_leasing_ai": "<script async src=\"https://cdn.leasing.ai/prod/v1/loader.js?pid=69db514f9eb73dfa48ba5a37\"></script>\n<img src=\"https://api.leasing.ai/v1/widgets/pixel/69db514f9eb73dfa48ba5a37\" width=\"1\" height=\"1\" style=\"display:none\" alt=\"\" />",
  "custom_realpage_id": "4600726",
  "custom_google_gtm_id": "GTM-NB7Q293",
  "custom_rollout_phase": "2",
  "custom_ads_subscription": "none",
  "custom_knock_company_id": "3165",
  "custom_seo_subscription": "essential",
  "custom_hubspot_company_id": "8443838469",
  "custom_knock_community_id": "e7e11f17c76e29ab",
  "custom_knock_company_token": "1f195820242ac1100a1b122d7087a021",
  "custom_social_subscription": "none",
  "custom_engrain_sightmap_url": "https://sightmap.com/embed/l27vqqgqvox",
  "custom_self_guided_tour_url": "https://selftournow.com/property/d3afd1b5-1548-4e73-b6a9-6d7676dc368b",
  "custom_website_subscription": "custom",
  "custom_knock_tour_button_popup": "<button onclick=\"event.preventDefault(); knockDoorway.openScheduling();\">Book tour</button>",
  "custom_ppc_tracking_phone_number": "346-585-7294",
  "custom_apartmentsync_javascript_id": "eyJpdiI6IkJhNlJISzlCdTMwWldxaDhZVDJSM3c9PSIsInZhbHVlIjoiWGsray9ZVUZrSUs1V2pnMEYyZkV6dz09IiwibWFjIjoiMzE5MDU3MTVkZGNhYjE5NTFmYzEyOGNlZmVlOTY2MzQ5NzViYTgxZTE2NTE3NmQ1YTdkNTgwMTYyZTY2ZGMyNyJ9",
  "custom_household_income_qualification_multiplier": "3",
  "custom_audioeye_site_id": "a8bd4edd-1374-4e5a-b03b-2d50c4379a83",
  "custom_audioeye_site_hash": "2e0b8d105237f31bf362f5cb9184336a"
};

export const generatedAt = '2026-11-03T20:34:03.526Z';
